<script>
	import PdfViewer from '../src/pdfviewer/PdfViewer.svelte';
	import { onMount } from 'svelte';
	import { fly } from 'svelte/transition';
  import Carousel from 'svelte-carousel'

	const embeddedVersion = true;

	let data = {
		pageTitle: "Dubai Collection",
		sections: [
			// {
			// 	id: "about", 
			// 	// menu: {en: "About", ar: "نبذة عن مقتنيات دبي"},
			// 	title: { en: "The Dubai Collection was launched under the patronage of His Highness Sheikh Mohammed bin Rashid al Maktoum the Vice President and Prime Minister of the United Arab Emirates (UAE), and ruler of the Emirate of Dubai. It is one of the key initiatives driven by Dubai Culture and Arts Authority and in collaboration with Art Dubai Group, with the aim of supporting the Authority’s Vision for the future of culture in Dubai. \n The Dubai Collection is the first institutional art collection in the city and for the city. It aims to inspire and educate those who live and visit Dubai, and support the thriving arts sector and all the creative professionals who call Dubai and UAE home.", ar: "أُطلقت مبادرة مقتنيات دبي برعاية كريمة من صاحب السمو الشيخ محمد بن راشد آل مكتوم، نائب رئيس الدولة رئيس مجلس الوزراء حاكم دبي. وهي أحد أهم مبادرات هيئة الثقافة والفنون في دبي والتي تنظمها بالتعاون مع مجموعة آرت دبي كجزء من رؤية الهيئة لتعزيز مستقبل قطاع الثقافة والفنون في إمارة دبي. \n تعد مقتنيات دبي هي المجموعة الفنية المؤسساتية الأولى من نوعها، والتي تهدف إلى إلهام وتوعية المجتمع المحلي ككل على أهمية دعم الفنون وتمكين القطاع الإبداعي المزدهر وجميع المبدعين المحترفين في دبي والإمارات." },
			// 	sub_title: { en: "More information coming soon.", ar: "التفاصيل والموقع الالكتروني الكامل قريباً." },
			// 	cover: "misk-dubai-art-dubai-contemporary-courtesy-of-photo-solutions.jpg",
			// 	type: "cover",
			// 	layout: "full",
			// },
			{
				id: "exhibition",
				layout: "full",
				type: "bigtitle",
				color: "blue",
				menu: {en: "Exhibition", ar: "دليل مجموعة دبي"},
				title: {en: "When Images Speak: \nHighlights from the Dubai Collection", ar: "عندما تتحدث الصور:\n معرض سيسلط الضوء على أبرز الأعمال الفنية المختارة من مجموعة"},
				// sub_title: {en: "Explore Guide", ar: "اكتشف الدليل"},
			},
			{
				id: "carousel",
				layout: "full",
				items: [
					{ lang: "en", carousel: {images: [
						{src: "Fateh-Moudarres-Levant-Borders.jpg", title: "Fateh Moudarres, Levant Borders, 1997. \nFrom the private collection of His Highness Sheikh Mohammed Bin Rashid Al Maktoum"},
						{src: "The-Falling-Dot-Dia-al-Azzawi.jpg", title: "Dia al-Azzawi, The Falling Dot, 1972. \nFrom the private collection of His Highness Sheikh Mohammed Bin Rashid Al Maktoum"},
						{src: "Naziha-Selim-Untitled.jpg", title: "Naziha Selim, Untitled, 1996. \nFrom the private collection of His Highness Sheikh Mohammed Bin Rashid Al Maktoum"}
					]}},
					{ lang: "ar", carousel: {images: [
						{src: "Fateh-Moudarres-Levant-Borders.jpg", title: "الفنان السوري فاتح المدرس – صورة ”حدود المشرق” – 1997. من المجموعة الشخصية لصاحب السمو الشيخ محمد بن راشد آل مكتوم"},
						{src: "The-Falling-Dot-Dia-al-Azzawi.jpg", title: "الفنان العراقي ضياء العزاوي ــ صورة ”النقطة الساقطة” ــ 1972، من المجموعة الشخصية لصاحب السمو الشيخ محمد بن راشد آل مكتوم"},
						{src: "Naziha-Selim-Untitled.jpg", title: "الفنانة العراقية نزيهة سليم – صورة بدون عنوان - 1996 - من المجموعة الشخصية لصاحب السمو الشيخ محمد بن راشد آل مكتوم"}
					]}},
					{ lang: "en", title: "Curated by Dr. Nada Shabout, the exhibition <em>When Images Speak: Highlights from the Dubai Collection</em> will present a selection of modern and contemporary art from across the region, tracing a historical survey of the negotiations through Arab modernism and its progression into contemporary trends, while highlighting the Gulf’s role in the documenting of art history as it was being written."},
					// { lang: "en", description: "Commenting on the announcement, <b>HH Sheikha Latifa bint Mohammed bin Rashid Al Maktoum, Chairperson of Dubai Culture & Arts Authority and Chair of the Dubai Collection’s Steering Committee</b>, said, <em>“The opening of When Images Speak is an important milestone in the Dubai Collection’s trajectory, as it presents the actualisation of an innovative initiative conceptualised right here in Dubai. This could not have happened without the trust of our patrons and their belief in the ambition of this project that seeks to bring art in the Emirate to the public and public spaces in the UAE and abroad; connect patrons with locally based artists; and collectively build Dubai’s art collection supporting its cultural sector.”</em>"},
					// { lang: "en", description: "She continued, <em>“We are delighted to feature in our first exhibition When Images Speak, artworks from the collection of, His Highness Sheikh Mohammed bin Rashid Al Maktoum, Vice President and Prime Minister of the United Arab Emirates and Ruler of Dubai. Having His Highness’s collection as a part of Dubai Collection’s first ever physical exhibition reflects His Highness’s commitment and support to the growth of the creative sector in Dubai.  The exhibition will present a rich narrative of 20th century Arab art, which will also highlight the role the Gulf played in documenting this artistic period. We look forward to welcoming the public to our inaugural exhibition at the Etihad Museum in November.”</em>"},
					// { lang: "en", description: "Commenting on the exhibition, <b>Dr. Nada Shabout, Curator of When Images Speak</b>, added: <em>“With the aim of creating a historical survey of modern and contemporary art from the region, When Images Speak will feature some of the most influential and progressive artists, all of whom played a pivotal role in shaping the modern movements in the region and reflect the socio-cultural dynamics of their time. The 20th century was one of major shifts that resulted in founding the different countries of the Arab World, following periods of colonization and struggles for independence. In forming national identities and iconography, those artists played a vital role that further aided in the construction of the national consciousness.”</em>"},
					{ lang: "en", description: "The first physical opportunity for the public to engage with works within the Dubai Collection, the exhibition will unfold across three thematic chapters, with the artworks acting as archival records of their time and narrating the history of art from the region over the last decades, while many of the groupings overlap and intersect thematically."},
					{ lang: "en", description: "Entitled Abstract Variations, and featuring pivotal artworks by artists Dia al-Azzawi and Omar El Nagdi, the first chapter of the exhibition will survey the topic of abstraction in modern Arab art. A heated topic of discussion and loaded political category among Arab artists during the mid- and second half of the 20th century, abstraction was a way of claiming identity and a form of resistance for some, while others questioned its ability to connect with the public and argued it prohibited art from playing a more direct role in national education. Abstraction was seen as a way to move towards the future, but also a way of reconnecting with the past."},
					{ lang: "en", description: "The second chapter in the exhibition, Societies in Transition, features artists’ investigations into society, history, family, mythologies, and culture. Works by artists such as Baya Mahieddine, Naziha Selim, and Asaad Arabi articulate the artists’ understanding and dialogues of the self through societal relationships as well as local struggles for independence and the formation of nations in a global context. Internationalism became a particularly important notion during this time, with artists seeking connection and engaging with movements from Europe as much as from other areas of the world, such as the Indian subcontinent. Defying a Western-imposed Orientalist narrative, these artists represented their own realities and people, and their works speak to resilience and creativity in the face of struggles."},
					{ lang: "en", description: "Evoking the Environment will be the third and final chapter of the exhibition. Through works by Fateh Moudarres, Abdul Qader Al Rais, and Nejib Belkhodja, amongst others, it reveals how painting cities became a method of constructing, and documenting, an ideal imaginary: the nation; while at others it registered the ongoing transformations of small towns and villages into larger urban spaces, as each country developed its modern identity."},
					{ lang: "en", description: "A critical element of the exhibition will be the focus on the UAE’s role in documenting a dynamic academic and intellectual exchange between many of the artists on show in this exhibition as well as the country’s active role, not just as a creative hub for artists, but also in writing the art history of its region."},
					{ lang: "en", description: "Published alongside the show, an eponymous digital catalogue, and featuring research by Dr. Nada Shabout, will help contextualize the works on show."},
					{ lang: "en", description: "Guided by an inclusive and collective outlook, the Dubai Collection is an opportunity for patrons to showcase their collections and for artists to have their artworks included in a publicly accessible platform. The Collection charts the history of the city and highlights Dubai’s vibrant and progressive identity, reaffirming its position as an international hub for art and culture."},
					{ lang: "en", description: "The first physical exhibition will coincide with the launch of the Digital Museum of the Dubai Collection, which will feature a catalogue of works included in the Dubai Collection and biographical information on each of the artists, alongside a host of editorial content around the history of collecting in the UAE, profiles of prominent patrons involved in the initiative and further information around the works."},
					{ lang: "en", description: "The Dubai Collection was developed in collaboration with the Art Dubai Group which continues to be the primary point of contact for its full operations, running activities on behalf of the Dubai Culture & Arts Authority."},
					{ lang: "en", sub_title: "When Images Speak: Highlights from the Dubai Collection will open at Etihad Museum on 6 November."},
					{ lang: "en", description: "For visitor information, please follow: <a href='https://etihadmuseum.dubaiculture.gov.ae/en/PlanYourVisit/Pages/default.aspx'>etihadmuseum.dubaiculture.gov.ae</a>"},

					{ lang: "ar", title: "تحت عنوان: ”عندما تتحدث الصور“”مقتنيات دبي“ تطلق أول معرض فني مفتوح للجمهور لتسليط الضوء على أبرز الإبداعات الفنية في العالم العربي"},
					{ lang: "ar", description: "في إطار سعيها للارتقاء بالذوق الفني للمجتمع وترسيخ مكانة دبي كوجهة عالمية للفن والثقافة، كشفت مبادرة ”مقتنيات دبي” عن إطلاق معرضها الفني الأول المفتوح للجمهور تحت عنوان: ”عندما تتحدث الصور: أبرز الأعمال الفنية في مجموعة مقتنيات دبي”. ويهدف المعرض الذي تشرف على تنظيمه أستاذة التاريخ والفلسفة الدكتورة ندى شبوط لتسليط الضوء على مجموعة منتقاة من أعمال الفن الحديث والمعاصر في المنطقة، والتي ترصد تاريخ تطور الحركات الفنية في العالم العربي من الحداثة حتى الاتجاهات الفنية المعاصرة، فضلًا عن إبراز دور منطقة الخليج في توثيق التاريخ الفني للمنطقة عبر الفترات الزمنية المختلفة."},
					{ lang: "ar", description: "وينقسم المعرض إلى ثلاثة أقسام تتناول ثلاثة موضوعات رئيسية. وسيتم التعبير عن كل موضوع باستخدام الأعمال الفنية المعروضة والتي تُعد بمثابة سجلات أرشيفية للحقبة الزمنية التي ظهرت فيها، حيث تسرد التطور التاريخي للحركة الفنية بالمنطقة على مدار العقود الأخيرة، لذلك قد يجد الزوار تداخلًا في بعض الأحيان بين المجموعات الفنية المختلفة نظرًا لتقاربها في الفترة الزمنية."},
					{ lang: "ar", description: "تحت عنوان ”منوعات تجريدية”، يعرض القسم الأول من المعرض عددًا من الإبداعات الفنية المتميزة للفنانين التشكيليين ضياء العزاوي وعمر النجدي. ويستعرض هذا القسم تطور الاتجاه التجريدي في الفن العربي الحديث. فقد جذب هذا الاتجاه الكثير من الفنانين العرب طوال النصف الثاني من القرن العشرين، حيث استخدموه كوسيلة للتأكيد على الهوية الوطنية وكشكل من أشكال المعارضة والمقاومة السياسية. وفي المقابل، كان هناك فريق آخر يشكك في قدرة الفن التجريدي على توصيل الأفكار للجمهور ويتهمونه بإعاقة الفن عن لعب دور أكبر في النظام الوطني للتعليم. وبشكل عام، كان يُنظر للفن التجريدي باعتباره وسيلة للتقدم نحو المستقبل وكذلك كوسيلة لإعادة التواصل مع الماضي."},
					{ lang: "ar", description: "أما القسم الثاني من المعرض ــ والذي يتم تنظيمه تحت عنوان ”مجتمعات في مرحلة انتقالية” ـــ فيتناول رؤى الفنانين حول المجتمع والتاريخ والأسرة والثقافة والأساطير. على سبيل المثال، تُعد أعمال الفنانين باية محي الدين ونزيهة سليم وأسعد عرابي بمثابة أحاديث مع الذات، حيث تعكس نظرة الفنانين لما يدور حولهم، وتعبر عن العلاقات الاجتماعية والكفاح الوطني من أجل الاستقلال في ذلك الوقت، كما تعكس نضال الدول لتأسيس هويتها الوطنية في ظل السياق العالمي السائد. وقد اكتسبت فكرة الأممية أهمية خاصة في هذه الحقبة، حيث سعى الفنانون للتواصل والتفاعل مع الحركات الفنية في أوروبا وغيرها من دول العالم (مثل شبه القارة الهندية). كما سعوا لمواجهة الأفكار التي حاول المستشرقون الغربيون فرضها على العالم العربي، وذلك من خلال التعبير عن واقعهم ومجتمعاتهم وشعوبهم. فقد اتخذوا من أعمالهم وسيلة لمواجهة الصراعات والافتراءات الغربية من خلال الفن والإبداع."},
					{ lang: "ar", description: "ويتم تنظيم القسم الثالث من المعرض تحت عنوان ”استحضار البيئة”، وهو يعرض عددًا من الأعمال الفنية البارزة لأشهر الفنانين العرب (مثل فاتح المدرس وعبد القادر الريس ونجيب بلخوجة)، والتي تم استلهامها من البيئة والسياق الخارجي السائد في تلك الفترة، حيث تعبر بعض الأعمال عن التصور المثالي للدولة أو ”الأمة”، بينما يستعرض بعضها الآخر كيفية تحول القرى والمدن الصغيرة إلى مناطق حضرية كبيرة في ظل سعي الدول لبناء هويتها الوطنية الحديثة. "},
					{ lang: "ar", description: "وتتمثل أحد الأهداف الرئيسية للمعرض في إبراز دور الإمارات كوجهة ثقافية عالمية للفنانين والمبدعين، فضلًا عن دورها في تمكين التبادل المعرفي والثقافي بين الفنانين وتوثيق تاريخ الفن في المنطقة. "},
					{ lang: "ar", description: "وسيتم توفير كتالوج رقمي أثناء المعرض يضم بحثًا للدكتور ندى شبوط، ويساعد الجمهور على التعرف على السياق أو الموضوع الذي تعبر عنه الأعمال الفنية المعروضة."},
					{ lang: "ar", description: "وتُعد مبادرة ”مقتنيات دبي” فرصة مثالية للرعاة والفنانين لعرض أعمالهم الإبداعية عبر منصة مفتوحة ومتاحة لقاعدة واسعة من الجمهور. وتهدف الأعمال الفنية المعروضة ضمن المبادرة لاستعراض تاريخ مدينة دبي العريق، والتعبير عن هويتها الديناميكية وسعيها الدائم للتطور والنجاح، فضلًا عن تعزيز مكانتها كوجهة عالمية للفن والثقافة."},
					{ lang: "ar", description: "ويأتي معرض ”عندما تتحدث الصور” تزامنًا مع انطلاق المتحف الرقمي الذي تنظمه مبادرة ”مقتنيات دبي” في نفس التوقيت، والذي يوفر كتالوجًا للأعمال الفنية المدرجة في المبادرة، بالإضافة للسير الذاتية لأصحاب هذه الأعمال. كما يوفر معلومات ثرية حول هواية اقتناء الأعمال الفنية في الإمارات، وكذلك معلومات إضافية حول الأعمال المعروضة والرعاة المشاركين في المبادرة."},
					{ lang: "ar", sub_title: "ويستعد المعرض لفتح أبوابه للجمهور في الرابع من نوفمبر المقبل تحت عنوان: ”عندما تتحدث الصور:  أبرز الأعمال الفنية في مجموعة مقتنيات دبي”"},
					{ lang: "ar", description: "<a href='https://etihadmuseum.dubaiculture.gov.ae/en/PlanYourVisit/Pages/default.aspx'>etihadmuseum.dubaiculture.gov.ae</a> للحصول على معلومات الزائر ، يرجى متابعة"},
				]
			},
			{
				id: "dubai-collection-guide",
				layout: "full",
				type: "bigtitle",
				color: "sand",
				menu: {en: "Dubai Collection Guide", ar: "دليل مجموعة دبي"},
				title: {en: "Dubai Collection Guide", ar: "دليل مجموعة دبي"},
				// sub_title: {en: "Explore Guide", ar: "اكتشف الدليل"},
				placeSubmenu: true
			},
			{
				id: "dubai-collection-guide",
				layout: "two-col-feature",
				// color: "green",
				type: "cover",
				cover: "misk-dubai-art-dubai-contemporary-courtesy-of-photo-solutions.jpg",
				submenu: {en: "Introduction", ar: "مقدمة"},
				// submenu: {en: "Dubai Collection Guide", ar: "دليل مجموعة دبي"},
				title: {en: "Introducing \nThe Dubai Collection", ar: "مقتنيات دبي نقدم لكم"},
				sub_title: {
					en: "The Dubai Collection will engage with themes connected with the historical development of the Emirate and the UAE and reflect the values of openness, diversity and interconnectedness as embodied in the spirit of its home.\n———\nWhilst focusing on the UAE and the region, the Dubai Collection is an international collection with no geographical restrictions and artworks will be selected by a qualified curatorial committee.\n———\nThe Dubai Collection will be built in partnership with patrons who support the initiative through an innovative format where they lend artworks whilst always retaining legal ownership.\n———\nPatrons can choose to include their artworks in temporary exhibitions or make them publicly accessible and all artworks in the Dubai Collection will be accessed through a digital museum",
					ar: "دبي” ستكون متاحة في المتحف الرقمي. جعلها متاحة للجمهور، كما أن ّ جميع األعمال الفنية المشاركة في “مقتنيات يستطيع الرعاة أن يختاروا مشاركة أعمالهم الفنية في المعارض المؤقتة أو\n———\nبالملكية القانونية. خالل منظومة مبتكرة تتيح لهم إعارة األعمال الفنية مع احتفاظهم المستمر تقوم مبادرة “مقتنيات دبي” على مبدأ الشراكة مع الرعاة الذين يدعمونها من\n———\nاألعمال الفنية من قبل لجنة تنظيمية ذات خبرة. إال أن “مقتنيات دبي” هي مجموعة عالمية دون قيود جغرافية، وسيتم اختيار بالرغم من أن التركيز سينصب على دولة اإلمارات العربية المتحدة والمنطقة؛\n———\nالمتجسدة في روح الدولة. ودولة اإلمارات العربية المتحدة، وستعكس قيم االنفتاح والتنوع والترابط ستتفاعل “مقتنيات دبي” مع مواضيع مرتبطة بالتطوّ ر التاريخي إلمارة دبي"
				},
			},
			{
				id: "governance",
				layout: "two-col-feature",
				color: "blue",
				submenu: {en: "Governance", ar: "الحوكمة"},
				title: {en: "Governance", ar: "الحوكمة"},
				sub_title:
					{
						en: "The Dubai Collection brings together a group of cultural leaders as advisors and an experienced executive team that will look after its development day to day. The Dubai Collection Steering Committee is chaired by Her Highness Sheikha Latifa bint Mohammed bin Rashid Al Maktoum and will ensure that the initiative reflects the open, forward looking and cosmopolitan spirit of Dubai and the UAE. An independent Curatorial Committee chaired by Muna al Gurg will be responsible for the selection of artworks and the overall curatorial direction of the Collection. The Art Dubai Group will manage the initiative, from ensuring the smooth running of the advisory committees to the production of exhibitions and digital content.",
						ar: "المعارض والمحتوى الرقمي الخاص بالمبادرة. دبي بإدارة المبادرة، وضمان آلية سلسة للجان االستشارية والعمل على تنفيذ للمجموعة، باإلضافة إلى تطوير البرنامج الخاص بالمجموعة. و يكمن دور آرت األعمال الفنية التي ستكون ضمن مجموعة “مقتنيات دبي”، والتوجيه العام السيدة منى القرق، مديرة إدارة المتاحف في دبي للثقافة، مسؤولية اختيار المنفتحة والمتطلعة إلى المستقبل. وتتولى لجنة التنظيم المستقلة برئاسة في مجلس دبي، لتعكس هذه المبادرة روح دبي واإلمارات العربية المتحدة بنت محمد بن راشد آل مكتوم، رئيسة هيئة الثقافة والفنون في دبي، وعضو المبادرة يوما ً بعد يوم. ترأس اللجنة العليا لـ“مقتنيات دبي” سمو الشيخة لطيفة بصفتهم مستشارين يمثلون فريقا ً تنفيذيا ً متمرسا ً يعمل على تنمية هذه تضم “مقتنيات دبي” مجموعة من القادة المتخصصين في المجال الثقافي"
					}
			},
			{
				id: "governance",
				layout: "two-col-feature",
				type: "quote",
				color: "green",
				title: {
					en: "No global city is complete without a fully developed cultural dimension. A vibrant cultural life and environment is an integral part of any economic hub. Dubai has many cultural assets that enable it to be a global cultural destination and a centre for talent and innovation.”", 
					ar: "وحاضنة رئيسية للمواهب والمبدعين” رقيّها ... ودبي تملك أصوال ً ثقافية وفنية تؤهلها لتكون وجهة ً ثقافية عالمية أي عاصمة اقتصادية عالمية ال تكتمل دون وجه ثقافي حضاري يعكس"
				},
				author: {en: "His Highness Sheikh Mohammed bin Rashid Al Maktoum", ar: "صاحب السمو الشيخ محمد بن راشد آل مكتوم"},
				sub_title: {en: "Vice President and Prime Minister of the United Arab Emirates (UAE), and ruler of the Emirate of Dubai", ar: "نائب رئيس دولة اإلمارات العربية المتحدة رئيس الوزراء حاكم إمارة دبي"},
				svg: "<svg version='1.1' id='skyline' xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 1260 430' xml:space='preserve'><path style='fill:none;stroke:var(--sand);stroke-width:calc(1px + 0.05vh + 0.05vw);' d='M1.5 428c1-.1 1.9-.1 2.9-.1 3.9.3 7.5-.1 10.9-2.6 2.2-1.6 5.3-2.5 8.1-3 9.2-1.6 18.4-2.8 27.7-4.2.8-.1 1.6-.1 2.5-.3 1.9-.3 3-1.2 3-3.3V412 289.3v-2.5c-.2-2.8-.7-3.3-3.6-3.4-3.6-.1-7.2 0-10.8 0-4 0-6-3-4.2-6.6.4-.8 1.9-1.5 3-1.6 3.9-.2 7.7-.1 11.6-.1 3.7-.1 4-.4 4-4v-43c0-2-.1-3.9 2.1-4.9 1.7-.8 1.4-2.5 1.4-4 0-7.7 0-15.4.1-23.1 0-1.4.3-2.8.5-4.5 2.4 1.2 1.9 2.8 1.9 4.2v29.3c0 .4-.2.9-.1 1.2.3.8.8 1.6 1.2 2.3.5-.6 1.1-1.1 1.3-1.8 1-2.6 1.2-2.8 3.7-1.1 7.6 5.1 14.4 11 20.3 18 2.5 2.9 4.9 6 7.2 9 1.4 1.8 2.9 2.6 5.2 2.7 3.3.1 6.6.8 9.7 1.6 1.2.3 2.7 1.7 3 2.9.5 1.9-1.2 2.9-2.8 3.5-1 .4-2.1.7-3.1 1-3.1.8-3.2 1-1.9 3.8 3.4 6.9 7.1 13.7 10.2 20.7 4.6 10.2 8.1 20.7 10.6 31.6 1.7 7.5 3.4 15 4.6 22.6 1.2 7.5 2.1 15 2.4 22.5.6 16.4.1 32.8-3.7 48.9-.8 3.3-.2 3.9 3.3 4.6 6.6 1.3 13.2 2.5 19.8 4.1 2.1.5 4.2 1.4 6 2.7 2.4 1.7 4.9 2.1 7.8 2.1 9.7-.1 19.3 0 29-.1 4.6 0 5.1-.3 4.9-4.9-.2-4.8 1.4-8.8 4.2-12.6 10.5-14.7 23.9-26.1 38.8-36.1 8.9-5.9 18.4-10.6 28.6-13.7 2-.6 3.3-1.4 3.4-3.9.1-2.5 4.3-5.7 7-5.8 2.2-.1 4.4.1 6.6-.1.9-.1 2.6-.8 2.6-1.3.3-4.6 4.2-4.3 7-5 2.4-.5 4.9-.1 7.4 0 1.6 0 2.3 1.1 2.9 2.5 2.3 4.5 4.4 9.1 7 13.5 2 3.4 4.5 6.4 6.8 9.6l1.1-.3c.1-1.4.4-2.8.4-4.2v-63.2c0-21.5.1-43 0-64.5 0-5.5.8-10.6 3.2-15.6 1.6-3.3 2.8-6.9 4.4-10.2 1.7-3.5 2.4-3.6 5.1-.9.2.2.5.2 1.2.4.2-4.2.3-8.3.5-12.4h1c0 2.2.1 4.5 0 6.7-.5 7.1.4 14 3.7 20.4 1.5 2.9 1.7 6 1.7 9.2v148.3c0 1.2.1 2.5 0 3.7-.2 2.4 1.3 3.5 3.1 4.5 1.6.9 2.7.4 2.9-1.5.2-1.1.1-2.2.1-3.3V253.3c0-8.4 0-16.8-.1-25.2 0-1.3 0-2.7 1.5-2.9 2.9-.5 2.8-2.6 2.8-4.7v-26c0-1-.2-2 .1-2.9.3-.9 1.1-1.6 1.6-2.4.6.8 1.3 1.6 1.6 2.5.3 1 .1 2.2.1 3.3v26c0 3.1 1.2 4.4 3.8 3.9.8-.1 1.6-1.2 2.1-2 .3-.7.1-1.6.1-2.4 0-11.2 0-22.3.1-33.5 0-1.4 0-2.8.3-4.1.1-.5.9-1.1 1.5-1.1.5 0 1.2.7 1.3 1.2.2 1.2.2 2.5.2 3.7 0 10.6 0 21.2-.1 31.8 0 1.1.1 2.2 0 3.3-.1 2.2.7 3.5 3.1 3.2h.4c4.4.3 4.5.3 4.5 4.9V401c0 1.2 0 2.5.2 3.7.3 1.5 1.4 2.4 2.9 2.3 1.9-.1 1.5-1.6 1.5-2.8 0-24.4 0-48.8.1-73.1 0-3.3.8-6.5 1.2-9.8.2-1.4.3-2.7.3-4.1 0-12.4 0-24.8.1-37.2 0-1.7.8-3.4 1.2-5 .3-1.4.8-2.9.9-4.4.1-2.3-.1-4.5 1.9-6.5 1.1-1.1 1.2-3.3 1.8-4.9.6-1.9.8-4.3 2.1-5.5 1.4-1.3 2.6-2.4 3.3-4.4.9-2.4 3.4-1.8 5.4-1.8 1.8 0 2.8.8 3 2.7 0 .5.1 1.4.4 1.5 3.2 1.2 3.4 4.2 4.4 6.8.4 1.1.8 2.3 1.2 3.4.2.6.1 1.6.5 1.9 3 2.1 3.5 5.3 3.9 8.3 0 .1 8.7.5 8.7 1.1 0 2.1-.1 6.9 0 13.7 0 .3-8.7.5-8.7.8.1 8.7-.1 20.5 0 33.5 0 .3 8.7.6 8.7.8v6.1c0 .3-8.7.6-8.7.9.2 17-.2 35.4 0 51.4 0 .3 8.7.5 8.7.8v6.9c0 .3-8.7.6-8.7.9.3 20.3-.3 35.3 0 35.9.4.7 3.1 1 4.2.9.9-.1 3.3-.8 3.5-1.6 1-2.8 1.4-151.6.9-154.8-.2-1.8.6-3.3 1.6-4.9 1.6-2.6 2.5-5.6 3.3-8.6.4-1.5.9-2.4 2.2-3.2.9-.6 1.8-1.7 2.1-2.7.6-2.1 1.9-2.5 3.7-2.5 1.9 0 4.1-.2 4.8 2.2.5 1.5 1 2.8 2.5 3.5.6.3 1 1.2 1.2 2 .8 2.6.7 5.8 2.3 7.7 2.7 3.2 1.8 7 3.1 10.2 3.1 7.8 1.5 15.7 1.8 23.5.3 7.3-.1 14.6-.2 21.9 0 .6-.1 1.1.1 1.6 3 8.7.9 17.7 1.6 26.6.1.9.1 1.8.2 2.8.2 0 .5 0 .7.1.4-1 .7-2.1 1.1-3.1.6-1.5 1.7-2.4 3.5-2.4 2.3.1 4.6 0 7 0 2.8 0 3.4-.6 2.1-3.1-1.4-2.5-1.7-5.1-1.9-7.9-.4-8 6.2-13 13.2-13.9 6-.8 13.2 6.4 13.8 13.1v.8c.1 5.7.1 5.7 5.9 4.3 2.4-.6 4.8-1.3 7.2-1.7 2.4-.5 3.3.2 3.4 2.7.1 3 0 6.1.1 9.1s.3 3.2 3.4 3.3c3.7.1 7.4 0 11.2 0 3.3.1 3.6.3 3.6 3.5.1 8.1.1 16.2.1 24.4v11.6c0 2.7 0 5.1-2.3 7.2-.8.7-1 2.3-1 3.4-.1 3.4-.1 6.9-.1 10.3.1 3.7 4 6.5 7.4 5.3.5-.2 1-.9 1.2-1.5.2-.9.1-1.9.1-2.9 0-42.3 0-84.6-.2-126.8 0-5.1 3.2-8.1 5.5-11.9.7-1.1 1.9-1 2.8 0 .9 1 1.8 2 2.6 3 1.5-1.3 2.9-2.4 4.1-3.7.7-.7 1.3-1.7 1.6-2.7.3-1 .1-2.2.1-3.3 0-2 .6-3.6 3-3.6 1.8-.1 2.8-.8 2.9-2.7.1-2-.6-3.4-2.7-4-1.5-.4-3.8-.6-3.7-2.6 0-2.4 2.6-2.1 4.1-2.5 6.8-1.9 13.6-1.8 20.3.3 1 .3 1.8 1.4 2.7 2.2-.8.8-1.6 1.7-2.5 2.3-.7.5-1.9.4-2.2.9-.8 1.1-1.6 2.5-1.7 3.8 0 .7 1.4 1.9 2.4 2.2 3.8 1.2 3.9 1.2 3.9 5 0 2.7.3 4.8 3.3 5.8.8.2 1.2 1.4 2 2.3.6-.4 1.2-.7 1.6-1.2 2.5-2.9 2.9-3 5.1 0 2.4 3.3 4.1 6.7 4 11.2-.2 27.3-.1 54.5-.1 81.8v2.9c.1 3.1.4 3.4 3.6 3.7 1.6.1 3.3 0 5 .1 1.1.1 2.5 0 3.1.7 2 2.2 4.4 1.9 6.9 1.9 3.6 0 7.2.1 10.8 0 3.5 0 5.2-1.7 5.6-5.2.1-1.1.1-2.2.1-3.3 0-12.8.1-25.6 0-38.4 0-2.1-.8-4.3-1.3-6.4-.6-2.3-1-4.2 1.4-5.8.8-.6 1.5-2 1.5-3.1-.1-2.7-.5-5.4-.9-8.2-.2-1.6-.7-3 1.2-4.3 1-.7 1.8-2.7 1.5-3.9-.7-2.8-1.1-5.3.4-7.9.4-.7-.1-1.9-.2-2.8-.1-1.7-.3-3.4 0-5.2 1.9 2 3.2 4 3 6.8-.1.9.3 1.9.7 2.7.8 1.6 1 3.1.2 4.7-1.2 2.3-1.4 4.5 1.4 5.9 1.5.8 1.3 2.2 1 3.7-.4 2.2-.9 4.3-1.1 6.5-.2 2.2-.8 4.6 2.4 5.8.7.3 1.3 2.9.9 4-2.2 5.2-1.6 10.6-1.6 15.9-.1 9.9 0 19.8 0 29.7 0 2.5-.1 4.9 1.6 7.1.6.7.4 2.1.5 3.1.1 1.2-.2 2.5.2 3.7.2.7 1.3 1.3 2.1 1.4.5.1 1.3-.9 1.5-1.5.3-.7.1-1.6.3-2.4.4-1.8 2.9-4 4.3-4s3.3 2 3.8 4c.1.7-.1 1.5.2 2 .4.7 1.1 1.3 1.7 1.9.4-.6 1-1.2 1.2-1.8.4-1 .3-2.2.7-3.1.8-1.6 2.2-3.1 4.2-2.7 1.9.3 3 1.9 3.3 3.8.1.8 0 1.7.2 2.5.2.6.9 1.4 1.1 1.4.7-.2 1.3-.7 1.8-1.3.3-.4 0-1.1.2-1.6.6-1.3 1.1-3 2.1-3.8 2.1-1.6 2.7-3.6 2.7-6.1-.1-6.1.2-12.1-.1-18.2-.2-4.3-.5-8.3.2-12.7.7-4.7 1.8-9.5 2-14.4 0-.2.3-.4.8-.9.3 1 .8 1.8.9 2.6l1.5 12.1c0 .4-.2.9 0 1.2 2.5 3.9.6 7.9.6 11.9v24.8c0 .6-.2 1.2.1 1.6.6.8 1.3 1.4 2 2.1.5-.7 1.3-1.3 1.5-2.1.3-1.7.3-3.6.4-5.3.3-5.3 3.6-9.6 8.5-11 .8-.2 1.9 0 2.7.4 5.9 2.5 8.6 6.8 8.4 13.3 0 1-.1 1.9.1 2.9.4 2.1 1.6 2.7 3.6 1.7.9-.4 1.6-1.1 2.5-1.4 1.4-.5 1.9-1.4 1.9-2.8v-5.4c.3-6.5 3.2-11.2 9.3-13.9 1.4-.6 2.4-1.9 3.3-2.6 1.1.8 2.1 2.1 3.5 2.7 5.9 2.7 8.6 7.4 9.3 13.6.1.9 0 1.9 0 2.9 0 5.5 0 5.5 5 7.1 1.8.6 3-.1 3.1-2 .2-1.6 0-3.3.1-5 .3-5.3 4.3-10.2 9.3-11.4.7-.2 1.6.1 2.3.4 1.4.5 2.7 1.2 4.7 2 .1-2.2.3-3.9.3-5.6v-84.7c0-8.8.1-7.7 7.5-7.9 1.6-.1 3.2-.7 4.8-.9 2.4-.3 4.9-.6 7.3-.7 3.9-.2 4.2-.5 4.2-4.4v-5c0-2.3.1-4.3 2.6-5.6.9-.4 1.3-2.3 1.4-3.5.1-2.3-.2-4.7-.2-7 0-1 .2-2.8.8-3 3-1.2 2.8-3.6 3-6.1.1-.7.8-1.8 1.3-1.8.7 0 1.5.7 2.2 1.1.6.4 1.2.9 1.7 1.4.4-.8 1.1-1.6 1.1-2.4.1-5.8 0-11.6 0-17.4 0-3.5.7-4.9 2.2-4.5 2.5.6 1.6 2.9 1.6 4.5V379c0 1.1-.1 2.3.2 3.3.2.6 1.1.9 1.7 1.4.3-.5.9-1 1-1.6.2-1.2 0-2.5.1-3.7.1-.9.1-2.2.6-2.7 2.2-2.1 2-4.7 2-7.3 0-12.3.1-24.5-.1-36.8 0-2.3-.8-4.6-1.6-6.7-1.3-3.5-1.2-4.2 1.5-6.7.8-.7 1.5-2.1 1.5-3.1-.1-2.6-.5-5.2-1-7.7-.3-1.7-.6-3.3 1-4.5 2.1-1.5 2.1-3.5 1.2-5.5-.8-1.8-.7-3.3 0-5.1.6-1.5.4-3.4.4-5.2 0-1.3-.4-2.6-.6-3.8.3-.1.5-.2.8-.3.5.5 1.1 1 1.3 1.6 1.2 4.2 3.6 8.2 2.3 12.9-.6 2.2-.7 4.4 1.8 5.8 1.5.8 1.2 2.2.9 3.7-.4 2.1-.9 4.3-1.1 6.5-.2 2.2-.2 4.3 2.2 5.8 1.7 1 1.3 3 .7 4.5-1.4 3.1-1.3 6.4-1.3 9.7v36.4c0 1.7.3 3.6.9 5.2.8 2.2 2.6 2.9 4.6 2.4 2.1-.6 1.6-2.3 1.6-3.7v-57.4c0-12 0-24 .1-35.9 0-2.1.7-4.3 1.5-6.3 3.4-8.1 7.1-16.1 10.5-24.2.9-2.1 1.3-4.5 1.3-6.8.2-7.2 0-14.3.1-21.5 0-1.6-1-4.4 1.4-4.5 2.6-.1 1.6 2.7 1.6 4.3.1 6.2.3 12.4 0 18.6-.3 5.6.9 10.9 2.2 16.3 1.7 6.5 3.5 13 5.1 19.6.6 2.4.8 4.9.8 7.4.1 27.7 0 55.4 0 83 0 1.9-.2 3.9.1 5.8.2 1 .9 2.5 1.8 2.8 2.4.8 2.6 2.5 2.6 4.6V423c0 .8-.2 1.7.1 2.5.2.8.8 1.6 1.2 2.4.6-.8 1.6-1.6 1.7-2.4.2-4.3.1-8.5 0-12.8-.1-13.2-.3-26.4-.3-39.7 0-46.4-.1-92.8.1-139.2 0-3.5 1-7.1 1.8-10.5 2-8.8 4.3-17.7 6.3-26.5.5-2 .6-4.1.6-6.1.1-7.4 0-14.9.1-22.3 0-1.5.5-3.1.8-5 2.2 1.3 1.8 3 1.8 4.4 0 7 .2 14.1 0 21.1-.1 3.7.8 7 2.4 10.3 4.1 8.3 8.1 16.6 12.1 24.8 1.4 2.9 2.1 5.8 2.1 9.1-.1 53.7 0 107.4 0 161.1 0 2.3 0 4.7.1 7 0 .7.3 1.5.7 3 .7-1.4 1.2-2.1 1.4-2.8.4-1.7 1.2-2.8 3-2.7 2.5.1 3-1.4 2.9-3.5v-6.6-47.5c0-2.7-.2-5.3 3.6-5.8.8-.1 1.7-2.1 1.8-3.2.2-2.9-.1-5.8-.1-8.7v-40.1c0-2.4 0-4.5 2.1-6.4 1-.9 1-3 1-4.6.1-17.8 0-35.5 0-53.3 0-4.9.2-5.1 4.9-5.7 3.1-.4 3.3-.5 3.3-4.4v-55.8-8.3c0-1.5.2-2.9 1.9-3.2 2.2-.4 2.4-2 2.3-3.7 0-4.8-.1-9.6 0-14.5.1-2.3.8-4.6 1-6.9.3-3.4.5-6.8.6-10.2.1-3-.4-6 1.9-8.6.7-.8.5-2.6.5-4V79.2c0-2.7-.3-5.5 1.3-8 .5-.8.4-2.1.3-3.2-.3-9.5.9-18.9 2.7-28.2.6-3.2.1-6.6.1-9.9v-5.4c2.3 1 1.8 2.4 1.8 3.5 0 10.9 0 21.8.1 32.6 0 1.5.8 3.1 1.1 4.6.3 1.2.7 2.4.8 3.5.1 3.9-.1 7.7.1 11.6.1 2.4.7 4.8 1 7.3.2 1.8.3 3.6.3 5.3.1 3.3 0 6.6 0 9.9 0 .8-.2 1.8.2 2.4 2.6 4.3 1.4 9.1 1.6 13.7.1 3.2-.1 6.3.1 9.5.1 2 .8 3.9 1.2 5.9.2 1.3.5 2.7.5 4.1v22.3c0 2.5-.1 4.7 3.2 5.2.7.1 1.5 1.4 1.8 2.3.3 1 .1 2.2.1 3.3V231c0 1.8.9 2.8 2.8 2.8.8 0 1.7 0 2.5.1 1.8 0 2.8.9 2.9 2.8.1 1.7.1 3.3.1 5 0 16.8 0 33.6-.1 50.4 0 2 .2 3.6 2 5.1 1 .8 1.2 2.9 1.2 4.5.1 14.7 0 29.5 0 44.2v2.9c0 1.6.6 2.4 2.3 2.8 3.4.8 3.2 1 3.2 4.5 0 12.8 0 25.6.2 38.4 0 3.4.3 3.6 3.9 3.9l2.5.3c1.4.3 2.1-.3 2.2-1.7 0-1.4.1-2.8.1-4.1 0-14.2.1-28.4 0-42.6 0-2.1-.6-4.3-1.3-6.3-.6-1.8-.8-3.5.1-5.2 2.1-3.7 1.7-7.4.2-11-.9-2.2-.9-4.1.1-6.3.7-1.4 1-3.2 1-4.8.1-6.6.1-13.2-.1-19.8 0-1.6-.4-3.3-1.1-4.7-1-2.1-.8-3.9 0-5.9 2-5 1.9-10.2.1-15.2-1.3-3.6-1.1-4.5 2.2-6.5.8-.5 1.8-1.6 1.8-2.5.3-3 .8-6.1-1-8.8-1-1.5-.8-2.6.4-4 1.1-1.3 2-3 2.4-4.7 1.6-6.3 3-12.6 4.5-18.9 0-.1 0-.3.1-.4.7-1.8 1.1-4 3.4-4.2 2.6-.3 3.1 2 3.6 3.8 1.5 5.7 2.9 11.5 4.4 17.2.7 2.5 1.7 4.9 2.9 7.1.7 1.4 1.1 2.5.2 3.8-2.2 3-.9 6.4-1 9.6 0 .6 1.1 1.4 1.8 1.8 3.1 1.5 3.9 3.3 2.5 6.5-2.3 5.2-2 10.2-.2 15.5.5 1.6.7 3.7 0 5.1-1.1 2.3-1.2 4.5-1.2 6.8 0 6.2-.1 12.4 0 18.6 0 1.6.4 3.2 1.1 4.7 1 2.2 1 4.1-.1 6.3-1.7 3.3-1.8 7 0 10.3 1.2 2.3 1 4.1.1 6.2-.6 1.5-1.1 3.1-1.1 4.7-.1 16.9 0 33.9 0 50.8 0 1.1 0 2.2.1 3.3.1 1.4.7 2.3 2.3 2.3 1.6 0 3.1-.2 3.4-2.2.1-.9.1-1.9.1-2.9 0-15 .1-30-.1-45 0-2.4-.8-4.8-1.3-7.2-.5-2.2-1.1-4.2 1.4-5.9.8-.5 1.3-2.1 1.2-3.2-.1-3.3-.4-6.6-.8-9.8-.2-1.8-.8-3.5 1-4.9 1.4-1.1.8-2.7.7-4.2-.2-2.7-.2-5.4 0-8.1.5-4.5 1.2-8.9 1.9-13.4.1-.6.8-1.1 1.2-1.7.2.6.5 1.1.6 1.7.3 1.3.4 2.6.7 4l.9 4.4c.4 2 .8 4 .9 6 .2 2.3 0 4.6 0 6.9.1 1.4-.1 3.3.6 4.2 1.4 1.7 1.2 3.2.9 5-.4 2.8-.6 5.7-.8 8.6-.2 2 0 3.8 1.8 5.2 1.4 1.1 1.4 2.7.8 4.2-1.6 4-1.3 8.1-1.4 12.2 0 13.5-.1 27-.1 40.5 0 1.6.2 3.1.3 4.7.3 0 .6.1.9.1.3-.6.8-1.3.8-1.9.1-2.9.2-5.8.1-8.7 0-2.3.8-3.6 3.2-3.9 4-.6 4-.7 4-4.6 0-33.9-.1-67.8-.1-101.6v-1.7c.2-3.1.5-3.6 3.6-3.8 2.6-.1 3.2-1.3 3.3-3.6.1-2.6.6-5.1.9-7.7v-.8c-.4-4.3-.4-4.4 3.9-4.4 4.7 0 9.4-.1 14.1 0 3.2.1 3.1.5 3 3.7-.1 3.6.4 7.3.8 10.9.2 1.6 1.6 1.6 2.8 1.8 3.8.5 3.9.5 3.9 4.2 0 23.4 0 46.8.1 70.2 0 1.6-.5 3.3 1.2 4.5 1.9-1.2 1.2-3 1.5-4.5.1-.5.8-.9 1.2-1.3.3.5 1 1.2.8 1.5-1.2 3.1.7 4.2 3 5.3 5.4 2.7 8.6 6.7 7.9 13.1-.3 3-.2 6.1 2.2 8.5 1.3 1.3 2.3 1.2 3.2-.5.1-.2.3-.5.3-.8-.3-5.1 2.4-8.5 7.1-11.1.5.6 1.1 1.8 2.1 2.4 2.4 1.6 3.6 3.6 3.4 6.6-.1 1.3.3 3.1 1.2 3.7 2.2 1.7 2.5 3.8 2.2 6.2-.1 1.4-.1 3.1 1.7 3.2 2 .1 4-.2 6-.6.3-.1.6-1.4.6-2.2 0-11.4.1-22.9-.1-34.3 0-1.9-.9-3.7-1.4-5.6-.5-1.8-.6-3.5 1.4-4.7.7-.4 1.4-1.5 1.4-2.3-.1-3.7-.4-7.4-.9-11-.3-1.8-.9-3.4.9-4.8 1.5-1.1 1.3-2.6.8-4.1-.9-2.7-.8-5.4.2-8.1.5-1.2.4-2.7.7-4l1.2-6.8c.1-1-.1-2.1.1-3.2 0-.4.5-.8.8-1.2.5.4 1.2.7 1.3 1.2.4 1.8.7 3.7.7 5.6.2 5.6 2.4 11 1.3 16.7-.2 1.2 0 2.9.8 3.8 1.4 1.5 1.1 2.9.9 4.6-.3 3.1-.5 6.3-.5 9.4 0 1.8.2 3.5 1.7 4.9.6.6 1 2.1.7 3-2.9 8.5-1.5 17.2-1.8 25.8-.1 5.1.2 10.2.1 15.3 0 2.2.8 3 2.9 2.9 1.5-.1 3 0 4.5.1 3.1.2 3.5.6 3.6 3.7.1 8.4 0 16.8 0 25.2 0 1.7-.1 3.3 0 5 .1 3.2.8 3.9 3.4 3.9 2.7 0 3.3-.6 3.3-3.9 0-11.7-.1-23.4 0-35.1 0-2 .4-4.1 1.2-5.9 3.1-6.9 12-7.1 16.4-2.9 1.6 1.5 2.8 2.4 5.3 2.1 1.5-.2 3.5 1.3 4.8 2.6 1.6 1.5 2.5 1.6 4 0 3.3-3.4 5.3-3.4 8.8-.3.8.7 2.1 1 3.1 1.4.3-1.1 1-2.2 1-3.3.1-5.6 0-11.3 0-16.9v-66.1c0-2.4-.2-4.7 2.8-5.7.7-.3 1.2-2 1.3-3.1.2-2 0-4.1.1-6.2.1-2.8.7-3.3 3.4-3.6.8-.1 1.7 0 2.5-.1 1.8-.1 2.7-1 2.6-2.9-.1-1.9-.1-3.9-.1-5.8 0-2.1 1.2-3.3 3.4-3.3 3.7 0 7.4 0 11.2.1 2.2 0 3.3 1.3 3.3 3.4.1 1.7 0 3.3.1 5 .2 3 .7 3.5 3.8 3.7 1.7.1 3.3.1 5 .1 2 0 3.1.9 3.1 3v2.1c.1 20.4.3 40.8.3 61.1 0 10.6-.1 21.2-.1 31.8 0 .9.1 2.1.7 2.6 1.8 1.7 3.8 3.1 5.8 4.5.4.3 1.5.2 1.8-.2.7-.8 1.7-1.8 1.8-2.7.4-4.2 1.1-8.3-.6-12.5-1.3-3.3-2-7.1 1.3-10.1.7-.6 1-2 1-3 .1-11.2 0-22.3 0-33.5-2.1-4.1-.2-7.5 1.8-11 .8-1.3.4-3.5.2-5.2-.3-1.9-.1-3.4 1.1-5 1.2-1.5 2-3.4 2.8-4.8 1.2 2 2.6 4.4 3.9 7 .4.8.3 1.9.1 2.8-.8 2.6-.3 4.9 1 7.1a10 10 0 011.3 7.8c-.7 2.9-.2 6-.2 9.1 0 8.1-.1 16.3 0 24.4 0 1.7 1 3.3 1.3 5 .7 3.6 2.6 6.8.2 10.8-1.3 2.2-.4 5.8-.4 8.8 0 .3.5.8.8.9 3.2.6 4.9 3.6 7.5 4.8 2.4 1.2 2.7 2.7 2.7 4.9-.1 8.8-.1 17.6-.1 26.4 0 2.3 0 4.7.1 7 .2 2.8.7 3.3 3.6 3.4 4 .1 8 0 12 .1m-1143-126.9c.7 3.3 1.1 6.7 2 9.9 2.7 9.4 4.4 19 5.2 28.7 1 11.2 1.3 22.5 1.4 33.8.1 6.3-.8 12.6-1.3 18.9-.3 3.5-.7 7.1-1.4 10.6-.7 3.6-1.7 7.2-2.5 10.8-.3 1.3-.5 2.8 1.3 3.5 1.6.5 3.3-.4 3.8-2.1.6-2.1 1-4.3 1.3-6.5.7-5.7 1.2-11.5 2-17.2 2.3-16.5 1.2-32.9-.7-49.3-.8-7.3-2.7-14.6-4.2-21.8-1.4-6.8-3.3-13.3-6.9-19.3zm-44.2-53.4h.1c0 3.2-.1 6.3 0 9.5.1 3 .7 3.6 3.7 3.6 3.2.1 6.3.1 9.5-.1 4.2-.2 5.9-3.1 3.8-6.7-3.8-6.4-8.6-12-14.2-17-.5-.5-1.4-.6-2-.9-.3.7-.8 1.4-.8 2.1-.2 3.1-.1 6.3-.1 9.5z'/></svg>"
			},
			{
				// id: "comittees", 
				id: "governance",
				// submenu: { en: "Committees", ar: "اللجان" },
				title: { en: "Chair of the Steering Committee", ar: "رئيس اللجنة التوجيهية" },
				type: "portrait",
				layout: "one-col",
				readmore: true,
				items: [
					{ lang: "en", cover: "hh-sheikha-latifa.jpg", title: "Her Highness Sheikha Latifa Bint Mohammed bin Rashid Al Maktoum" , description: "Her Highness Sheikha Latifa bint Mohammed bin Rashid Al Maktoum is actively engaged in culture, arts, education, and technology in the UAE, and plays a major role in ensuring the cross-incubation of these industries through her post as Chairperson of Dubai Culture & Arts Authority. \nUnder her patronage and leadership, Dubai Culture has launched its flagship Dubai Art Season, which includes Art Dubai, the leading international art fair in the region, and SIKKA Art Fair, an artist-led initiative of fully commissioned works. Additional initiatives held under her patronage include Dubai Design Week, the region’s largest creative festival; and Global Grad Show, the world-first exhibition of graduate works from leading design and technology universities."},
					{ lang: "ar", cover: "hh-sheikha-latifa.jpg", title: "سمو الشيخة لطيفة بنت محمد بن راشد آل مكتوم", sub_title: "رئيسة اللجنة العليا", description: "العالمــي، وهــو أول معرض عالمي ألعمال الدراســات العليا من جامعات التصميــم والتكنولوجيا الرائدة. بنــت محمد بن راشــد آل مكتوم: أســبوع دبــي للتصميم، وهو أكبر مهرجان إبداعي فــي المنطقة؛ ومعرض الخريجين المنطقة، ومعرض ســكة الفني، وغيرهم. و من بين المبادرات األخرى التي تقام تحت رعاية ســمو الشــيخة لطيفة موســم دبــي الفنــي والذي يضــم مجموعة من الفعاليات الفنية الرائدة مثــل: معرض آرت دبي العالمي الرائد في أطلقت هيئة الثقافة والفنون في دبي تحت رعاية وقيادة ســمو الشــيخة لطيفة بنت محمد بن راشــد آل مكتوم، \nهــذه القطاعــات اإلبداعية من خالل منصبها رئيســة لهيئة دبي للثقافــة والفنون (دبي للثقافة). والفنــون والتعليــم والتكنولوجيــا فــي دولة اإلمارات العربيّة المت ّ حدة، وتلعب دورا ً رئيســيا ً في ضمان حضانة وتطوير تشــارك ســمو الشــيخة لطيفة بنت محمد بن راشــد آل مكتوم بصورة فعالة في النشــاطات المرتبطة بالثقافة"},
				]
			},
			{
				// id: "comittees", 
				id: "governance",
				title: { en: "Members of the Steering Committee", ar: "أعضاء اللجنة التوجيهية" },
				type: "portrait",
				layout: "two-col",
				readmore: true,
				items: [			
					{ lang: "en", cover: "noura-al-kaabi.jpg", title: "H.E. Noura bint Mohammed Al Kaabi" , description: "Al Kaabi has been President of Zayed University since 2018 and Chair of the National Commission for Education, Culture and Science. She is the chairperson of the Higher Committee for UAE Pavilion at Expo Dubai 2021. \nShe is on the Board of Trustees of the International Institute for Tolerance, in addition to being the vice chair of the Abu Dhabi Media Company. \nShe was the first Emirati to be chosen by the Foreign Policy magazine as one among the 100 global thinkers in 2013. The Forbes Middle East Council named her among the 30 most influential Arab women in the government sector. In 2015, she was honored by the American Association for Foreign Media (AAM) in recognition of her role in the growth of the UAE media industry. \nShe holds a BA in Management Information Systems from the United Arab Emirates University. She completed an Executive Leadership Program at London Business School in 2011."},
					{ lang: "ar", cover: "noura-al-kaabi.jpg", title: "الكعبي معالي نورة بنت محمد", sub_title: "عضوة اللجنة العليا", description: "لندن لألعمال” عام 2011. برنامج القيادة التنفيذية في “كلية اإلمارات العربية المتحدة”، وأكملت المعلومات اإلدارية من “جامعة حاصلة على بكالوريوس في نظم\nاإلمارات العربية المتحدة. في نمو صناعة اإلعالم في دولة الخارجي (AAM) تقديرا ً لدورها قبل الجمعية األمريكية لإلعالم وجرى تكريمها، في العام 2015، من مجلس “فوربس الشرق األوسط”، الحكومي في العالم العربي” في 30 امرأة عربية تأثيرًا في القطاع كما أ ُ درجت ضمن قائمة “أكثر “أبرز 100 مفكر عالمي” عام 2013، العالمية كأول إماراتية ضمن قائمة اختارتها مجلة “فورين بوليسي”\nلإلعالم”. رئيس مجلس إدارة “شركة أبوظبي للتسامح”، باإلضافة إلى منصب نائبة في مجلس أمناء “المعهد الدولي تشغل معاليها منصب عضوة\nاإلمارات في إكسبو دبي 2021. ومنصب رئيسة اللجنة العليا لجناح الوطنية للتربية والثقافة والعلوم، منذ العام 2018، ورئيسة اللجنة الكعبي منصب رئيسة جامعة زايد تشغل معالي نورة بنت محمد"},
					{ lang: "en", cover: "abdelmonem-bin-eisa-alserkal.jpg", title: "Abdelmonem Bin Eisa Alserkal", description: "Emirati businessman and patron Abdelmonem Bin Eisa Alserkal is the founder of Alserkal, a socially responsible cultural enterprise, and its initiatives: Alserkal Avenue, Alserkal Arts Foundation, and Concrete. Concrete was shortlisted for the 2019 Aga Khan Award for Architecture. \nAbdelmonem serves on the boards of numerous art and business institutions around the world, including the British Museum’s Contemporary and Modern Middle Eastern Art Acquisition Group; the Tate’s Middle East and North Africa Acquisition Committee; the Guggenheim’s Middle Eastern Circle; and Etisalat Telecommunications Group Company PJSC (Etisalat). He is also a Supporter of the Centre Pompidou International Circle – Middle East. \nAbdelmonem is also the managing director of Nasser Bin Abdullatif Alserkal Est., a Dubai-based family business with diversified interests in the UAE and internationally, and serves as a member of the board of the Alserkal Group. \nAbdelmonem and the Alserkal family have long been supporters of the arts and have been awarded the UAE Patron of the Arts award twice."},
					{ lang: "ar", cover: "abdelmonem-bin-eisa-alserkal.jpg", title: "السركال عبد المنعم بن عيسى", sub_title: "عضو اللجنة العليا", description: "الفنون” اإلماراتية مرتين. الفنون، وقد حصلوا على جائزة “راعي لطالما كان السركال وعائلته من رعاة\nمجموعة السركال. ومنصب عضو في مجلس إدارة المتحدة وعلى الصعيد الدولي، متنوعة في دولة اإلمارات العربية عائلية مقرها دبي تمارس نشاطات عبد اللطيف السركال، وهي شركة المدير التنفيذي لمؤسسة ناصر بن إضافة لذلك، يتولى السركال منصب\nالشرق األوسط. مجموعة مركز بومبيدو الدّولي ّ في (اتصاالت)، وهو أيض ً ا أحد داعمي في مؤسسة اإلمارات لالتصاالت غوغنهايم، وعضو مجلس إدارة الشرق األوسط التابعة لمتحف التابعة لمتحف “Tate”، ومجموعة في الشرق األوسط وشمال إفريقيا للمتحف البريطاني، ولجنة االقتناء األوسط المعاصرة والحديثة التابعة فيها مجموعة اقتناء فنون الشرق الفنون واألعمال حول العالم، بما مجالس إدارة العديد من مؤسسات يشغل السركال منصب عضو في\nلجائزة آغا خان للعمارة لعام 2019. الذي تم إدراجه في القائمة المختصرة السركال للفنون”، ومبنى “كونكريت” وهي: “السركال أفنيو”، و”مؤسسة اجتماعيًا، والمبادرات التابعة لها وهي مؤسسة ثقافية مسؤولة والثقافة وم ُ ؤسس “السركال”، رجل األعمال اإلماراتي وراعي الفنون عبد المنعم بن عيسى السركال هو"},
					{ lang: "en", cover: "he-abdulrahman-al-owais.jpg", title: "H.E. AbdulRahman bin Mohammed Al Owais" , description: "His Excellency Abdul Rahman Al Owais (UAE, 1967) is a Cabinet Member and Minister of Health and Prevention and Minister of State for Federal National Council Affairs. He joined the federal Government in 2006 as the Minister of Culture, Youth and Community Development. Chairman of the Dubai Culture and Arts Authority, he is a Board Member of Dubai Healthcare City, the Chairman of the Board of Trustees of Hamdan bin Mohammed bin Rashid Al Maktoum International Photography Award, Member of the Board of Trustees for the Sheikh Hamdan Bin Rashid Al Maktoum Awards for Medical Sciences, Member of the Board of Directors of the Emirates Foundation for Philanthropy and a Member of the Board of Trustees of Sultan Bin Ali Al Owais Cultural Foundation since 1992. He is also the 1st Vice President of the UAE National Olympic Committee."},
					{ lang: "ar", cover: "he-abdulrahman-al-owais.jpg", title: "العويس معالي عبد الرحمن", sub_title: "عضو اللجنة العليا", description: "الوطنيّة. نائب الرئيس األول للجنة األولمبية منذ عام 1992. باإلضافة لكونه سلطان بن علي العويس الثقافية وعضو في مجلس األمناء لمؤسسة مؤسسة اإلمارات للنفع االجتماعي، للعلوم الطبية، وعضو مجلس إدارة الشيخ حمدان بن راشد آل مكتوم الضوئي، وعضو مجلس أمناء جائزة بن راشد آل مكتوم الدولية للتصوير مجلس أمناء جائزة حمدان بن محمد سلطة مدينة دبي الطبية، ورئيس للثقافة)، وهو عضو مجلس إدارة هيئة دبي للثقافة والفنون (دبي معاليه منصب رئيس مجلس إدارة إلى جانب عمله الوزاري، يشغل وتنمية المجتمع. عام 2006 كوزير للثقافة والشباب العويس إلى الحكومة االتحادية في االتحادي. انضم معالي عبد الرحمن الدولة لشؤون المجلس الوطني الصحة ووقاية المجتمع، ووزير منصب عضو مجلس الوزراء، ووزير يشغل معالي عبد الرحمن العويس"},
					{ lang: "en", cover: "mohamed-al-murr.jpg", title: "H.E. Mohammad Al-Murr" , description: "His Excellency Mohammad Al-Murr (UAE, 1955) is Chairman of the Dubai Historical District Development Committee, Chairman of the Mohammed bin Rashid Al Maktoum Library Foundation and a Trustee of the Emirates Literature Foundation. He graduated from Syracuse University in the United States and has been a member of several UAE academic institutions and councils. In 2011 Al Murr was appointed to the Federal National Council’s 15th Chapter as a representative of the Emirate of Dubai and served as the speaker from 2011 to 2015. Mohammad Al-Murr is also a short-story writer who has published over 15 volumes of short stories and has had two collections translated into English: Dubai Tales and The Wink of the Mona Lisa."},
					{ lang: "ar", cover: "mohamed-al-murr.jpg", title: "معالي محمد المر", sub_title: "عضو اللجنة العليا", description: "و”غمزة الموناليزا”. اإلنجليزيّة وهما: “حكايات دبي” مجموعاته القصصية إلى اللغة القصيرة، وت ُ رجمت مجموعتين من قصيرة ونشر 15 مجلدا ً من القصص معالي محمد المر كاتب قصص خالل الفترة ما بين 2011 إلى 2015. إلمارة دبي، وانت ُ خب ناطقا ً باسمه عشر للمجلس االتحادي ممثال ً عُ يّن معاليه في الفصل الخامس دبي للثقافة والفنون. في عام 2011، المت ّ حدة. وهو الرئيس السابق لهيئة األكاديمية في دولة اإلمارات العربيّة في عدد من المؤسسات والمجالس في الواليات المتحدة، وكان عضوا ً تخرج معاليه من جامعة “سيراكوز” وأمين مؤسسة اإلمارات لآلداب. مكتبة محمد بن راشد آل مكتوم دبي التاريخية، ورئيس مؤسسة رئيس اللجنة العليا لتطوير منطقة يشغل معالي محمد المر منصب"},
					{ lang: "en", cover: "muna-easa-al-gurg.jpg", title: "Muna Easa Al Gurg" , description: "Muna Easa Al Gurg is a businesswoman and philanthropist from Dubai. She is Director of Retail at Easa Saleh Al Gurg Group and is on several boards of directors including for non-profit organizations. Muna is Chairwoman of Young Arab Leaders, a fellow of the Middle East Leadership Initiative of the Aspen Institute, a member of the Aspen Global Leadership Network and board member of Al Gurg Charity Foundation. \nSince 2008, has been Chairwoman of Young Arab Leaders UAE. In 2015 she launched the Muna Al Gurg Scholarship at London Business School. Al Gurg is a member of the United Nations High Commissioner for Refugees Sustainability Board, mandated to provide innovative and sustainable solutions to refugees in the MENA region. \nAt the Easa Saleh Al Gurg Charity Foundation, she is responsible for strategy and initiatives both in the UAE and internationally, including primary education support for underprivileged children in Zanzibar. Muna has been listed in the ‘Women of Influence in the Arab world 2021’ by CEO Middle East."},
					{ lang: "ar", cover: "muna-easa-al-gurg.jpg", title: "منى عيسى القرق", sub_title: "عضوة اللجنة العليا", description: "2021”. قائمة “أكثر النساء تأثيرًا في العالم العربي اختارتها مجلة CEO Middle East ضمن\nالمحرومين في زنجبار. بما فيها دعم التعليم األساسي لألطفال العربية المتحدة وعلى المستوى الدولي، ومبادرات المؤسسة في دولة اإلمارات تتولى القرق مسؤولية استراتيجيات “مؤسسة عيسى صالح القرق الخيرية”، وبوصفها عضوة ً في مجلس إدارة\nاألوسط وشمال إفريقيا. ومستدامة لالجئين في منطقة الشرق الالجئين، والمكلف بتقديم حلول مبتكرة المفوضية السامية لألمم المتحدة لشؤون تشغل أيض ً ا منصب عضوة في مجلس القرق” في “كلية لندن لألعمال”، كما أنها أطلقت القرق في عام 2015 “منحة منى\nاإلمارات العربية المتحدة منذ عام 2008. “منظمة القيادات العربية الشابة” في دولة تشغل القرق منصب رئيسة مجلس إدارة\nمجلس إدارة مؤسسة القرق الخيرية. معهد آسبن للقيادة العالمية”، وعضوة لمعهد آسبن”، وعضوة في “شبكة في “مبادرة القيادة في الشرق األوسط “منظمة القيادات العربية الشابة”، وزميلة تتولى القرق منصب رئيسة مجلس إدارة\nالمنظمات غير الربحية. إدارة العديد من المؤسسات، بما في ذلك صالح القرق” ومنصب عضوة في مجالس مديرة أعمال التجزئة في “مجموعة عيسى وخيرية من دبي. تشغل القرق منصب منى عيسى القرق هي سيدة أعمال تجارية"}
				]
			},
			{
				// id: "comittees", 
				id: "governance",
				title: { en: "Chair of the Curatorial Committee", ar: "رئيس اللجنة الذاتية" },
				type: "portrait",
				layout: "one-col",
				readmore: true,
				items: [
					{ lang: "en", cover: "muna-al-gurg.jpg", title: "Muna Faisal Al Gurg" , description: "Muna Faisal Al Gurg (UAE, 1987) studied Visual Arts at Zayed University, Dubai. She went on to receive a M.A. in History of Art and Museum Studies from the Paris-Sorbonne University in Abu Dhabi. Muna joined the Dubai Culture & Arts Authority in 2012, as a collections specialist and went on to work on the Authority’s museum development projects. \nMuna has extensive, specialised experience in the museum sector and has already led several successful projects, including her effective role in the launch of the Etihad Museum as a platform that encourages cultural exchange and educates Emirati youth about their history and heritage. In 2015, Muna was appointed as a member of the Board of Trustees of the Museum of the Future."},
					{ lang: "ar", cover: "muna-al-gurg.jpg", title: "منى فيصل القرق", sub_title: "رئيسة اللجنة التنظيمية", description: "درست منى فيصل القرق (من مواليد الإمارات، 1987) الفنون البصرية في جامعة زايد، دبي، ثم حصلت على درجة الماجستير في تاريخ الفن ودراسات المتاحف من جامعة باريس السوربون في أبوظبي. انضمت القرق إلى هيئة دبي للثقافة والفنون عام 2012 بصفتها متخصصة في المجموعات، ثم بدأت في العمل على مشاريع تطوير المتاحف التابعة للهيئة."}
				]
			},
			{
				// id: "comittees", 
				id: "governance",
				title: { en: "Members of the Curatorial Committee", ar: "أعضاء اللجنة" },
				type: "portrait",
				layout: "two-col",
				readmore: true,
				items: [
					{ lang: "en", cover: "munira-al-sayegh.jpg", title: "Munira Al Sayegh", description: "Munira Al Sayegh (UAE, 1989), an independent curator based in Abu Dhabi, UAE, worked with NYUAD as an assistant producer on the FIND project (2012), as co-curator of Art Dubai Projects (2014), assistant curator of Emirati Expressions (2015), and curator of Bayn: the in-between, the third edition of U.A.E Unlimited (2017). \nAl Sayegh was a curator on the Guggenheim Abu Dhabi exhibition The Creative Act: Performance, Process, Presence (2017), which she worked on alongside the Guggenheim Abu Dhabi project as programmes officer (2015-2017) and whilst curating the Abu Dhabi Art talks programme (2017). \nIn 2019, she curated the Residents section of Art Dubai, was the lead tutor for Campus Art Dubai and started the Now series, highlighting non-government funded creative platforms in the region. \nIn 2020, Al Sayegh curated her biggest exhibition The Cup and The Saucer, commissioned by Warehouse421."},
					{ lang: "ar", cover: "munira-al-sayegh.jpg", title: "منيرة الصايغ", sub_title: "عضوة اللجنة التنظيمية", description: "منيرة الصايغ (من مواليد الإمارات، 1989) هي قَيِّمة مستقلة مقرها أبوظبي، عملت مع جامعة نيويورك أبوظبي كمنتج مساعد في مشروع 'فايند' (2012)، وكقيّمة مشاركة في مشاريع آرت دبي (2014)، وكقيّمة مساعدة في مشروع 'تعابير إماراتية' (2015)، وكقيّمة في معرض 'بين' في نسخته الثالثة والذي نظمته 'أ.ع.م اللامحدودة' (2017). عملت الصايغ أيضًا كقيّمة في معرض غوغنهايم أبوظبي على مشروع 'مسارات إبداعية: تفاعل، تشكيل، تواجد' (2017)، والذي قامت به إلى جانب تنظيمها لمشاريع غوغنهايم أبوظبي بصفتها مسؤولة برامج (2015-2017)، وأيضًا خلال إشرافها على برنامج 'حوارات فن أبوظبي' (2017). أشرفت الصايغ، في عام 2019، على قسم 'الفنان المُقيم' في آرت دبي، وعملت كمدربة رئيسة في 'كامبس آرت دبي'، وبدأت سلسلة 'الآن' التي تسلّط الضوء على المنصات الإبداعية غير الممولة من الحكومة في المنطقة. قامت الصايغ أيضًا في العام 2020 بالإشراف على أكبر معرض في مسيرتها المهنية وهو 'التأرجح: سياقات عبثية' بتكليف من Warehouse421."},
					{ lang: "en", cover: "nada-shabout.jpg", title: "Nada Shabout", description: "Dr. Nada Shabout (UK, 1962) is a Professor of Art History and Coordinator of the Contemporary Arab and Muslim Cultural Studies Initiative (CAMCSI) at the University of North Texas, and is the founding president of the Association for Modern and Contemporary Art from the Arab World, Iran and Turkey (AMCA). \nAlong with curating exhibitions and receiving a number of prestigious awards, Shabout was the Project Advisor for the Saudi National Pavilion, Venice Biennale 2019, has been elected to the College Art Association (CAA) Board of Directors (2020-2024), and appointed a member of the Board of Directors of the Visual Arts Commission at the Ministry of Culture of Saudi Arabia (2020-2023). \nLeading an AMCA team, she received a Getty Foundation Grant to support the project “Mapping Art Histories from the Arab World, Iran and Turkey” and, in addition, is working on a book, Demarcating Modernism in Iraqi Art: The Dialectics of the Decorative, 1951-1979, with the American University in Cairo Press."},
					{ lang: "ar", cover: "nada-shabout.jpg", title: "ندى شبوط", sub_title: "عضوة اللجنة التنظيمية", description: "ندى شبوط (من مواليد المملكة المتحدة، 1962 ) هي أستاذة تاريخ الفن ومنسقة مبادرة الدراسات الثقافية العربية والإسلامية المعاصرة في جامعة شمال تكساس بالولايات المتحدة الأمريكية، كما أنها الرئيسة المُؤسِسة لـ”رابطة الفن الحديث والمعاصر من العالم العربي وإيران وتركيا”. إلى جانب تنظيم المعارض وحصولها على عدد من الجوائز المرموقة، شغلت شبوط منصب مستشارة المشروع للجناح الوطني السعودي في بينالي البندقية عام 2019، وتم اختيارها للانضمام لمجلس إدارة جمعية كلية الفنون (2020-2024)، وتم تعيينها كعضوة مجلس إدارة في الجمعية السعودية للفنون التشكيلية بوزارة الثقافة السعودية (2020-2023). خلال قيادتها لفريق “رابطة الفن الحديث والمعاصر من العالم العربي وإيران وتركيا”، حصلت شبوط على منحة من مؤسسة “جيتي” لدعم مشروع “تخطيط تاريخ الفن من العالم العربي وإيران وتركيا”، بالإضافة إلى ذلك، تعمل شبوط على تأليف كتاب يسمى “ترسيم الحداثة في الفن العراقي: ديالكتيك الزخرفة”، 1951-1979، بالتعاون مع الجامعة الأمريكية بالقاهرة."},
					{ lang: "en", cover: "antonia-carver.jpg", title: "Antonia Carver", description: "Antonia Carver (UK, 1971) is Director of Art Jameel, leading teams in Saudi Arabia and the UAE, and overseeing programmes across learning and the arts. She joined in 2016 with a mandate to develop the Jameel Arts Centre, Dubai (which opened as Dubai’s contemporary arts museum in November 2018), and Hayy Jameel, Jeddah (opening November 2021), and to institute a new period of radical growth for the organisation. Among other roles, Carver was previously Director of Art Dubai (2010-2016); Projects Director at Bidoun; in strategy and programming at Dubai International Film Festival; an editor at Phaidon; and has written extensively on Middle Eastern art and film."},
					{ lang: "ar", cover: "antonia-carver.jpg", title: "نتونيا كارفر", sub_title: "عضوة اللجنة التنظيمية", description: "أنتونيا كارفر (من مواليد المملكة المتحدة، 1971) هي مديرة مركز جميل للفنون، وتتولى قيادة مجموعة من الفرق الفنية في دولة الإمارات العربية المتحدة والمملكة العربية السعودية، والإشراف على البرامج التعليمية والفنية. شاركت كارفر، في عام 2016، في تطوير مركز جميل للفنون، دبي (الذي افتتح كمتحف للفنون المعاصرة في المدينة في نوفمبر عام 2018)، و 'حي جميل'، جدة (الذي افتتح في نوفمبر 2021)، وساهمت في ترسيخ فترة جديدة من النمو الكبير الذي شهده المركز. شغلت كارفر أيضًا مناصب أخرى، حيث توّلت منصب مديرة 'آرت دبي' (2010-2016)، ومديرة المشاريع في 'بدون'، ومسؤولة في قسم الاستراتيجيات والبرامج في مهرجان دبي السينمائي الدولي، ومحررة في 'فايدون'، كما أنها كتبت مقالات حول مجموعة واسعة من المواضيع المتعلقة بالفن والسينما في الشرق الأوسط."},
					{ lang: "en", cover: "maryam-al-dabbagh.jpg", title: "Maryam Al Dabbagh", description: "Maryam Wissam Al Dabbagh (UAE, 1982) is a writer, researcher, and the co-founder of Rouya Consultancy, specialising in cultural communications. She received a BA in Journalism from the American University of Sharjah and an MA in Global Media and Post-National Communications from SOAS, London. Her research is focused on the Arab Diaspora in the Gulf, and exile, especially through the lens of language, belonging and return. Al Dabbagh has translated several art catalogues and books to Arabic, and was recently commissioned by Art Jameel as part of their experimental research and exhibition series: The Library Circles."},
					{ lang: "ar", cover: "maryam-al-dabbagh.jpg", title: "مريم الدباغ", sub_title: "عضوة اللجنة التنظيمية", description: "مريم وسام الدباغ (من مواليد الإمارات، 1982) هي مؤلفة وباحثة وشريك مؤسس في 'رؤيا للاستشارات'، شركة متخصصة في الاتصالات الثقافية. حصلت الدباغ على درجة البكالوريوس في الصحافة من الجامعة الأمريكية في الشارقة وماجستير في الإعلام العالمي وأشكال الاتصالات ما بعد الوطنية من كلية الدراسات الشرقية والأفريقية، لندن. تُركّز بحوث الدباغ على عرب المهجر في الخليج، والمنفى، لا سيما من خلال عدسة اللغة والانتماء والعودة. قامت الدباغ بترجمة العديد من الإصدارات والكتب الفنية إلى اللغة العربية، وتم تكليفها مؤخرًا من قبل مركز جميل للفنون للعمل على مشروع: حلقات المكتبة، كجزء من معارضه وسلسلة أبحاثه التجريبية."},
					{ lang: "en", cover: "venetia-porter.jpg", title: "Venetia Porter", description: "Venetia Porter (UK, 1955) is a curator of Islamic and Contemporary Middle East art at the British Museum. She has a BA in Arabic and Persian, an MPhil in Islamic Art from the University of Oxford and a PhD from the University of Durham on the history and architecture of Medieval Yemen. \nShe has curated two major exhibitions at the British Museum, Word into Art (2006) and Hajj: journey to the heart of Islam (2012) and was the lead curator for the Albukhary Foundation Gallery of the Islamic World which opened in October 2018. \nHer research and publications, including Islamic Tiles (1995), Arabic and Persian Seals and Amulets in the British Museum (2011) range from Arabic inscriptions to contemporary art and she is a contributor to The Islamic World: A history through objects (2018)."},
					{ lang: "ar", cover: "venetia-porter.jpg", title: "فينيشيا بورتر", sub_title: "عضوة اللجنة التنظيمية", description: "فينيشيا بورتر (من مواليد المملكة المتحدة، 1955) هي قيّمة قسم “الفن الإسلامي والمعاصر في الشرق الأوسط” في المتحف البريطاني. تحمل بورتر درجة البكالوريوس في اللغة العربية والفارسية، ودرجة الماجستير في الفن الإسلامي من جامعة أكسفورد، ودرجة الدكتوراه من جامعة دورهام في “التاريخ والعمارة في اليمن في العصور الوسطى”. عملت بورتر على تنظيم معرضين رئيسين في المتحف البريطاني وهما “كلمة في الفن” (2006) و “حج: رحلة إلى قلب الإسلام” (2012)، وتولّت منصب القيّمة الرئيسة في “معرض مؤسسة البخاري للعالم الإسلامي” الذي افتتح في أكتوبر 2018. ركّزت أبحاثها ومنشوراتها التي تتضمن “البلاط الإسلامي” (1995)، و”الأختام العربية والفارسية والتمائم في المتحف البريطاني” (2011)، على النقوش العربية وحتى الفن المعاصر، كما أنها ساهمت في تأليف كتاب “العالم الإسلامي: تاريخ من خلال الأشياء (2018)."},
					{ lang: "en", cover: "catherine-david.jpg", title: "Catherine David", description: "Catherine David (France, 1954) is a French-born art historian and curator and Deputy Director of Musée National d’Art Moderne, Paris. She has worked at the Musée National d’Art Moderne, Centre Georges Pompidou, the Galerie Nationale du Jeu de Paume, Paris and the Witte de With Center of Contemporary Art in Rotterdam. In 1997, she was Artistic Director for documenta X in Kassel and in 1998, served as Director of Contemporary Arab Representations." },
					{ lang: "ar", cover: "catherine-david.jpg", title: "كاترين ديفيد", sub_title: "عضوة اللجنة التنظيمية", description: "كاترين ديفيد (من مواليد فرنسا، 1954) هي مؤرخة فنية فرنسية، وقيّمة ونائبة مدير المتحف الوطني للفنون الحديثة، باريس. عملت ديفيد في المتحف الوطني للفنون الحديثة، ومركز جورج بومبيدو، والمعرض الوطني في 'جو دي بوما'، باريس، ومركز 'وت دو وذ' للفن المعاصر في روتردام. شغلت ديفيد أيضًا، في عام 1997، منصب المديرة الفنية لقسم التوثيق في كاسيل بألمانيا، وعملت في العام 1998 كمديرة لقسم التصورات العربية المعاصرة." }
				]
			},
			{
				id: "selection-process",
				layout: "two-col-feature",
				color: "sand",
				type: "cover",
				submenu: {en: "Selection Process", ar: "عملية الاختيار"},
				title: {en: "Selection Process \n<em>KEY FACTS</em", ar: "<em>حقائق رئيسية</em>\n عملية الاختيار"},
				sub_title: {
					en: "Artworks in the Dubai Collection will engage with themes connected with the historical development of Dubai and the UAE from the second half of the 20th century up to the present day and looking into the future\n———\nWhilst focusing on the UAE and the region, the Dubai Collection is an international collection with no geographical restrictions\n———\nRegardless of provenance, all artworks are expected to reflect the values of openness, diversity and interconnectedness as embodied in the spirit of Dubai and the UAE\n———\nAll artworks are subject to due diligence to ensure their legitimate provenance",
					ar: "ستخضع جميع األعمال الفنية لإلجراءات الالزمة لضمان شرعية مصادرها.\n———\nالعربية المتحدة. المختارة قيم االنفتاح والتنوع والترابط المتجسدة في روح دبي واإلمارات وبصرف النظر عن مصدر هذه األعمال الجغرافي، ستعكس األعمال الفنية\n———\nإال أن مقتنيات دبي هي مجموعة عالمية دون قيود جغرافية. بالرغم من أن التركيز سيكون على روح وتاريخ دولة اإلمارات العربية المتحدة،\n———\nمن القرن العشرين حتى اليوم وتطلعا ً للمستقبل. بالتطور التاريخي إلمارة دبي ودولة اإلمارات العربية المتحدة منذ النصف الثاني ستتفاعل األعمال الفنية المختارة ضمن “مقتنيات دبي” مع مواضيع مرتبطة"					
				},
				cover: "HH-Sheikh-Mohammed-bin-Rashid-Al-Maktoum-Vice-President-and-Prime-Minister-of-the-United-Arab-Emirates.jpg",
			},
			{
				id: "selected-artworks",
				layout: "two-col-feature",
				color: "white",
				type: "cover",
				submenu: {en: "Selected Artworks", ar: "أعمال فنية مختارة"},
				title: {en: "Selected Artworks", ar: "أعمال فنية مختارة"},
				sub_title: {
					en: "Following the first official curatorial committee review and selection process, 87 new artworks entered Dubai Collection alongside the personal collections of founding patrons His Highness Sheikh Mohammed bin Rashid Al Maktoum, Her Highness Sheikha Latifa bint Mohammed bin Rashid Al Maktoum and the corporate art collection of A.R.M Holding, marking an important achievement in the development of Dubai’s innovative new institutional art collection. Included in the acquisitions are works by many leading modern Arab artists, including Baya (Algeria, 1931 – 1998), Fateh Moudarres (Syria, 1922–1999), Chafic Abboud (Lebanon, 1926-2004), Adam Henein (Egypt, 1929 -2020) and Moath Alofi (Saudi Arabia, 1984). An important focus in the acquisitions are works by leading Emirati artists, such as Abdul Qader Al Rais (UAE, 1951), Mohamed Ahmed Ibrahim (UAE, 1962), Lamya Gargash (UAE, 1982) and Shaikha Al Mazrou (UAE, 1988).",
					ar: "بعد المراجعة والاختيار الأولى للجنة التنسيق الرسمية ، دخل 87 عملاً فنياً جديداً إلى مجموعة دبي إلى جانب المجموعات الشخصية للرعاة المؤسسين صاحب السمو الشيخ محمد بن راشد آل مكتوم ، وصاحبة السمو الشيخة لطيفة بنت محمد بن راشد آل مكتوم والمجموعة الفنية المؤسسية من ARM عقد ، يمثل إنجازًا مهمًا في تطوير مجموعة الفن المؤسسي الجديد والمبتكر في دبي. تضمنت المقتنيات أعمال العديد من الفنانين العرب المعاصرين البارزين ، بما في ذلك بياعة (الجزائر ، 1931-1998) ، فاتح المدرس (سوريا ، 1922-1999) ، شفيق عبود (لبنان ، 1926-2004) ، آدم حنين (مصر ، 1929 - 2020) ومعاذ العوفي (السعودية 1984). من النقاط المهمة في عمليات الاستحواذ أعمال كبار الفنانين الإماراتيين ، مثل عبد القادر الريس (الإمارات العربية المتحدة ، 1951) ، ومحمد أحمد إبراهيم (الإمارات العربية المتحدة ، 1962) ، ولمياء قرقاش (الإمارات العربية المتحدة ، 1982) ، والشيخة المزروع (الإمارات العربية المتحدة ، 1988) ."
				},
				cover: "Mohamed-Ahmed-Ibrahim-Sitting-Man-2013-Oil-on-Canvas-81-x-65-cm-each-Courtesy-the-artist-and-Lawrie-Shabibi.jpg",
			},
			{
				id: "patrons",
				layout: "two-col-feature",
				color: "blue",
				submenu: {en: "Patrons", ar: "الرعاة"},
				title: {en: "Dubai Collection Patrons", ar: "رعاة مقتنيات دبي"},
				sub_title: {					
					en: "Patronage is at the heart of the Dubai Collection. Some Patrons will have built museum quality collections thanks to decades of passion and dedication, others will be purchasing artworks for the first time. Regardless of where they are on their journey, the Patrons of the Dubai Collection will all contribute to building a legacy and documenting the history of Dubai.",
					ar: "دبي وتوثيقه. تواجدهم في رحلتهم، سيسهم جميع رعاة “مقتنيات دبي” في بناء إرث تاريخ فيما سيقوم آخرون بشراء المقتنيات الفنية ألول مرة. بغض النظر عن مكان مجموعات من المتاحف عالية الجودة بفضل عقود من الشغف والتفاني، إن الرعاية هي جوهر “مقتنيات دبي” ، فبعض الرعاة الفنيين قد أقاموا بالفعل"
				},
			},
			{
				id: "patrons",
				layout: "two-col-feature",
				color: "sand",
				type: "cover",
				title: {en: "<em>KEY FACTS</em", ar: "<em>حقائق رئيسية</em>"},
				sub_title: {					
					en: "Patrons are the legal owners of their works, which they choose to lend to the Dubai Collection\n———\nA special loan agreement secures the inclusion of each artwork in the Collection for at least a decade\n———\nPatrons commit to make artworks either publicly accessible or support their inclusion in temporary exhibitions\n———\nPatrons can lend existing artworks in their collection or make new acquisitions for which, if they wish, they can seek advice from the Dubai Collection Curatorial Committee\n———\nPatrons can choose to be publicly recognised for their contribution, or remain anonymous if they choose",
					ar: "يظلوا مجهولي الهوية إذا اختاروا ذلك. كما يستطيع الرعاة أن يختاروا اإلفصاح عن هويتهم في مساهمتهم، أو أن\n———\nاللجنة التنظيمية الخاصة بـ”مقتنيات دبي”. عمليات استحواذ جديدة، ويمكنهم إذا رغبوا في ذلك، أن يطلبوا المشورة من ويمكن للرعاة إعارة األعمال الفنية الموجودة في مجموعتهم أو أن يجروا\n———\nفي معارض مؤقتة. ويلتزم الرعاة بجعل األعمال الفنية إما متاحة للجمهور أو دعمهم مشاركتها\n———\nعشر سنوات على األقل. وهناك اتفاقية إعارة خاصة تضمن إدراج كل عمل فني في المجموعة لمدة\n———\nإعارتها لـ”مقتنيات دبي”. إن رعاة هذه المبادرة هم المالكون الشرعيون ألعمالهم، والذين يقررون"
				},
				cover: "Galleria-Continua-Art-Dubai-Contemporary-2018-Courtesy-of-Photo-Solutions.jpg",
			},
			{
				id: "loan-agreement",
				layout: "two-col-feature",
				color: "blue",
				submenu: {en: "Loan Agreement", ar: "اتفاقية اإلعارة"},
				title: {en: "Loan Agreement", ar: "اتفاقية اإلعارة"},
				sub_title: {
					en: "The Dubai Collection Loan Agreement is the legal foundation of the initiative and aims to formalise its core principles. It sets the parameters for the inclusion of each individual artwork in the Collection and regulates the relationship between Patrons and the Dubai Collection.", 
					ar: "الرعاة وبين “مقتنيات دبي”. المعايير الالزمة إلدراج أي عمل فني فردي في المجموعة، وتنظم العالقة بين إلى إضفاء الطابع الرسمي والقانوني على مبادئها األساسية. كما أنها تحدد إن اتفاقية اإلعارة لمقتنيات دبي هي األساس القانوني للمبادرة وتهدف"
				},
			},
			{
				id: "loan-agreement",
				layout: "two-col-feature",
				color: "sand",
				type: "cover",
				title: {en: "<em>KEY FACTS</em", ar: "<em>حقائق رئيسية</em>"},
				cover: "Ayyam-Gallery-Dubai-Art-Dubai-Contemporary-Art-Dubai-2019-Courtesy-of-Photo-Solutions.jpg",
				sub_title: {
					en: "Artworks become the object of a Loan Agreement once they are approved for inclusion in the Dubai Collection by the Curatorial Committee\n———\nThe agreement is established between the Patron’s legal entity - be it an individual or an organisation - and Dubai Culture, who legally represents the Dubai Collection\n———\nIt protects the Patron’s ownership rights whilst ensuring mechanisms are in place to enable the public to enjoy the artworks in different formats\n———\nIt sets the timeframe for inclusion of each artwork in the Dubai Collection, as well as enabling digital content related the artwork to become publicly accessible in perpetuity\n———\nThe agreement does not regulate the inclusion of artworks in special temporary exhibitions, which will be established separately with the relevant venues and always with the Patron’s permission", 
					ar: "الراعي. وستكون هناك اتفاقيات مستقلة مع الجهات ذات الصلة، ودائما ً بإذن من ال تنظم اتفاقية اإلعارة إدراج األعمال الفنية في المعارض المؤقتة الخاصة،\n———\nتمكيــن الوصــول إلى المحتوى الرقمي المرتبط باألعمــال الفنية علنا ً إلى األبد. يحــدد اإلطــار الزمني إلدراج أي عمل فني فــي “مقتنيات دبي”، فضال ً عن\n———\nلتمكين الجمهور من االستمتاع باألعمال الفنية بتنسيقات مختلفة. يعمل على حماية حقوق الملكية الخاصة بالرعاة مع ضمان اآلليات الالزمة\n———\nهيئة الثقافة والفنون في دبي والتي تمثل “مقتنيات دبي” بصورة قانونية. ويكون االتفاق بين الكيان القانوني للراعي، سواءً كان فردا ً أو منظمة، وبين\n———\n“مقتنيات دبي”. تخضع األعمال الفنية التفاقية اإلعارة بمجرد اعتماد لجنة التنظيم إلدراجها في"
				},
			},
			{
				id: "supporting-creative-talent",
				layout: "two-col-feature",
				color: "blue",
				submenu: {en: "Supporting Talents", ar: "دعم المواهب"},
				title: {en: "Supporting creative talent", ar: "المواهب اإلبداعية دعم"},
				sub_title: {
					en: "The Dubai Collection will offer a platform for emerging talent whilst celebrating the career of established artists. In all cases it will ensure that artists included in the Collection have a track record that demonstrates their commitment to a creative practice.", 
					ar: "في المجموعة سجل يُظهر التزامهم بالممارسات اإلبداعية. المحترفين. وفي جميع الحاالت، تضمن هذه المبادرة أن يكون لدى الفنانين تقدم “مقتنيات دبي” منصة للمواهب الفنية الناشئة، وتحتفل بمسيرة الفنانين"
				},
			},
			{
				id: "supporting-creative-talent",
				layout: "two-col-feature",
				color: "sand",
				type: "cover",
				title: {en: "<em>KEY FACTS</em", ar: "<em>حقائق رئيسية</em>"},
				cover: "Grosvenor-Gallery-London-Art-Dubai-Modern-March-20-Art-Dubai-2019-Courtesy-of-Photo-Solutions.jpg",
				sub_title: {
					en: "The Dubai Collection will only consider artworks from emerging and established artists that can meet the criteria below\n———\nEstablished artists will have a demonstrable track record of works exhibited in an institutional context (temporary exhibitions or permanent collections) or by reputable and established private galleries\n———\nEmerging artists will have a demonstrable track record of professional development as shown by participation in reputable art initiatives, including but not limited to exhibitions, residencies, group shows and established international fairs", 
					ar: "الحصر المعارض، واإلقامات، والعروض الجماعية، والمعارض الدولية. المشاركة في مبادرات فنية حسنة السمعة، بما في ذلك على سبيل المثال ال يجب أن يكون للفنانين الناشئين سجل واضح من التطور المهني، يوضح\n———\nخاصة معروفة. سياق مؤسسي (معارض مؤقتة أو مجموعات دائمة) أو بواسطة معارض يجب أن يكون للفنانين المحترفين سجال ً موثقا ً باألعمال الفنية المعروضة في\n———\nالذين يُمكنهم استيفاء المعايير أدناه. ستنظر مجموعة دبي فقط في األعمال الفنية للفنانين الناشئين والمحترفين"
				},
			},
			{
				id: "collection-displays",
				layout: "two-col-feature",
				// color: "blue",
				// type: "cover",
				submenu: {en: "Collection Displays", ar: "المقتنيات عرض"},
				title: {en: "Collection Displays", ar: "المقتنيات عرض"},
				// cover: "Elmarsa-Gallery-Tunis-and-Dubai-Art-Dubai-Modern-Art-Dubai-2019-Courtesy-of-Photo-Solutions.jpg",
				sub_title: {
					en: "Accessibility is one of the core principles of the Dubai Collection. The Collection can be experienced by audiences in multiple ways:\n———\nWorks will be physically on display in accessible locations across the city Works will be brought together as part of curated exhibitions in galleries and museums in the UAE and abroad\n———\nA Digital Museum will bring together educational material and critical perspectives on the Collection to support research and satisfy curiosity anywhere in the world.", 
					ar: "من العالم. حول المجموعة لدعم البحوث وإشباع الفضول الفني واإلبداعي في أي مكان وسوف يجمع المتحف الرقمي بين المواد التعليمية ووجهات النظر المهمة\n———\nدولة اإلمارات العربية المتحدة وخارجها.\n———\nست ُ عرض األعمال، من خالل معارض فنية منظمة، في المعارض والمتاحف في\n———\nست ُ عرض األعمال فعليا ً في مواقع يسهل الوصول إليها في جميع أنحاء إمارة دبي.\n———\nيمكن لجمهورنا تجربة المجموعة بطرق متعددة: إن إمكانية الوصول هي أحد المبادئ األساسية لمبادرة “مقتنيات دبي”، حيث"
				}
			},
			{
				id: "collection-displays",
				layout: "two-col-feature",
				color: "sand",
				type: "cover",
				title: {en: "<em>KEY FACTS</em", ar: "<em>حقائق رئيسية</em>"},
				cover: "Elmarsa-Gallery-Tunis-and-Dubai-Art-Dubai-Modern-Art-Dubai-2019-Courtesy-of-Photo-Solutions.jpg",
				sub_title: {
					en: "The Dubai Collection will encourage and support Patrons to make artworks publicly accessible in suitable venues they own or rent across the city, to help build a city-wide ‘distributed museum’\n———\nThe Dubai Collection will develop and help produce temporary exhibitions to extend the reach of the Collection across the UAE and abroad, whilst working with leading international cultural venues to develop exchange programmes\n———\nWith the latest technologies and digital archiving methods, the Dubai Collection Digital Museum will become a resource and evolving archive through which the Collection will reach a global audience", 
					ar: "جمهور عالمي. األرشفة الرقمية، مرجعا ً وأرشيفا ً متطورا ً يمكن من خالله الوصول إلى سيصبح متحف “مقتنيات دبي” الرقمي، بتوظيف أحدث التقنيات وأساليب\n———\nالجهات الثقافية العالمية لتطوير برامج التبادل. المجموعة في اإلمارات العربية المتحدة وفي الخارج، مع العمل مع أهم وستقوم “مقتنيات دبي” بتطوير وإنتاج معارض مؤقتة لتوسيع نطاق\n———\nللمساعدة في بناء متحف فني وتجربة فنية استثنائية على مستوى دبي. الوصول إلى األعمال الفنية في األماكن التي تمتلكها أو تستأجرها عبر اإلمارة، تشجع “مقتنيات دبي” الرعاة وتدعم أعمالهم الفنية بحيث تمكنهم من"
				},
			},
			{
				id: "contact-dubai-collection",
				layout: "two-col-feature",
				color: "blue",
				title: {en: "Download Guide", ar: "اتصل بنا"},
				// submenu: {en: "Contact", ar: "اتصل"},
				sub_title: {
					en: "For quick access to the Dubai Collection Guide, <b><a href='../pdf/Dubai-Collection-Guide-English-27-4-21.pdf'>download here</a></b>.<br><br>To learn more about how to support the Dubai Collection, \nplease email: \n<b><a href='mailto:info@dubaicollection.ae'>info@dubaicollection.ae</a></b>",
					ar: "<b><a href='../pdf/Dubai-Collection-Guide-Arabic-3-5-21.pdf'>تنزيل هنا</a></b> للوصول السريع إلى دليل مجموعة دبي.<br><br>للوصول السريع إلى دليل مجموعة دبي <b><a href='mailto:info@dubaicollection.ae'>info@dubaicollection.ae</a></b> \nلمعرفة المزيد حول “مقتنيات دبي”، يرجى التواصل معنا على البريد اإللكتروني:"
				},
			},
			// {
			// 	id: "guide", 
			// 	menu: {en: "Dubai Collection Guide", ar: "دليل مقتنيات دبي"},
			// 	title: { en: "Dubai Collection Guide", ar: "دليل مقتنيات دبي" },
			// 	sub_title: { en: "All you need to know about the Dubai Collection", ar: "كل ما تحتاج معرفته عن مقتنيات دبي" },
			// 	type: "download",
			// 	layout: "center-one-col",
			// 	items: [
			// 		// { embed: "<iframe allowfullscreen='true' style='border:none;width:100%; min-height:400px; height:70vh; max-height:1200px;' src='//e.issuu.com/embed.html?d=dubai_collection_booklet_27.4.21_329e9f0cb78387&hideIssuuLogo=true&u=artdubai'></iframe>"}
			// 		{
			// 			lang: "en",
			// 			// description: "All you need to know about the Dubai Collection",
			// 			cover: "dubai-collection-guide.jpg",
			// 			link: "../pdf/Dubai-Collection-Guide-English-27-4-21.pdf",
			// 			hideButton: true
			// 		},
			// 		{
			// 			lang: "ar",
			// 			// description: "كل ما تحتاج معرفته عن مقتنيات دبي",
			// 			cover: "dubai-collection-guide.jpg",
			// 			link: "../pdf/Dubai-Collection-Guide-Arabic-3-5-21.pdf",
			// 			hideButton: true
			// 		}
			// 	]
			// },			
			{
				id: "press", 
				menu: {en: "Press", ar: "المركز الإعلامي"},
				title: { en: "Press Releases", ar: "الأخبار الصحفية" },
				type: "download",
				layout: "two-col",
				items: [
					{ 
						lang: "en", 
						description: "The Dubai Collection Announces First Physical Exhibition", 
						cover: "Fateh-Moudarres.jpg",
						link: "../pdf/Press-Release-Dubai-Collection-Announces-First-Physical-Exhibition-EN.docx",
						link2: "../pdf/Press-Release-Dubai-Collection-Announces-First-Physical-Exhibition-EN.pdf"
					},
					{ 
						lang: "ar", 
						description: "تعرض مجموعة من المقتنيات الفنية الشخصية المُقدَّمة من صاحب السمو الشيخ محمد بن راشد آل مكتوم", 
						cover: "Fateh-Moudarres.jpg",
						link: "../pdf/Press-Release-Dubai-Collection-Announces-First-Physical-Exhibition-AR.docx",
						link2: "../pdf/Press-Release-Dubai-Collection-Announces-First-Physical-Exhibition-AR.pdf"
					},
					{ 
						lang: "en", 
						description: "First Artworks Enter The Dubai Collection", 
						cover: "Mohamed-Ahmed-Ibrahim-Sitting-Man-2013-Oil-on-Canvas-81-x-65-cm-each-Courtesy-the-artist-and-Lawrie-Shabibi.jpg",
						link: "../pdf/Press-Release-First-Artworks-Enter-The-Dubai-Collection-EN.pdf"
					},
					{ 
						lang: "ar", 
						description: "أول الأعمال الفنية تدخل مجموعة دبي", 
						cover: "Mohamed-Ahmed-Ibrahim-Sitting-Man-2013-Oil-on-Canvas-81-x-65-cm-each-Courtesy-the-artist-and-Lawrie-Shabibi.jpg",
						link: "../pdf/Press-Release-First-Artworks-Enter-The-Dubai-Collection-AR.pdf"
					},
					{ 
						lang: "en", 
						description: "Lafita bint Mohammed announces Steering and Curatorial Committees for the Dubai Collection", 
						cover: "ayyam-gallery-dubai-art-dubai-contemporary-courtesy-of-photo-solutions.jpg",
						link: "../pdf/announcing-the-steering-and-curatorial-committees-en.pdf"
					},
					{ 
						lang: "ar", 
						description: "لطيفة بنت محمد تعلن عن أعضاء اللجنة العليا واللجنة التوجيهية لمقتنيات دبي", 
						cover: "ayyam-gallery-dubai-art-dubai-contemporary-courtesy-of-photo-solutions.jpg",
						link: "../pdf/announcing-the-steering-and-curatorial-committees-ar.pdf"
					},
					{ 
						lang: "en", 
						description: "Announcing the launch of the Dubai Collection", 
						cover: "dubai-collection-1.jpg",
						link: "../pdf/Dubai-Collection-Annoucement-EN.pdf"
					},
					{ 
						lang: "ar", 
						description: "الإعلان عن إطلاق مقتنيات دبي", 
						cover: "dubai-collection-1.jpg",
						link: "../pdf/Dubai-Collection-Annoucement-AR.pdf"
					}
				]
			},
			{
				id: "press", 
				title: { en: "Press Coverage", ar: "تغطية صحفية" },
				type: "download",
				layout: "two-col",
				items: [
					{ 
						lang: "en", 
						link_label: "Art Served Us In Our Hour Of Need \nNow We Must Support It",
						author: "Her Highness Sheikha Latifa bint Mohammed bin Rashid Al Maktoum",
						date: "02/05/2021",
						link: "https://www.thenationalnews.com/opinion/comment/art-served-us-in-our-hour-of-need-now-we-must-support-it-1.1214609"
					},
					{ 
						lang: "ar", 
						link_label: "الفنون محور نهضة المجتمعات", 
						author: "الشيخة لطيفة بنت محمد بن راشد آل مكتوم",
						date: "02/05/2021",
						link: "https://www.alkhaleej.ae/2021-05-02/%D8%A7%D9%84%D9%81%D9%86%D9%88%D9%86-%D9%85%D8%AD%D9%88%D8%B1-%D9%86%D9%87%D8%B6%D8%A9-%D8%A7%D9%84%D9%85%D8%AC%D8%AA%D9%85%D8%B9%D8%A7%D8%AA/%D9%8A%D9%88%D9%85%D9%8A%D8%A7%D8%AA-%D8%AB%D9%82%D8%A7%D9%81%D9%8A%D8%A9/%D8%AB%D9%82%D8%A7%D9%81%D8%A9"
					}
				]
			},
			{
				id: "contact", 				
				menu: { en: "Contact", ar: "للتواصل" },
				title: { en: "Contact", ar: "للتواصل" },
				type: "contact",
				layout: "full",
				items: [
					{ email: "info@dubaicollection.ae" },
					{ link: "https://www.instagram.com/thedubaicollection_/" },
					{ link: "https://twitter.com/thedubaicollect" },
					{ link: "https://www.facebook.com/TheDubaiCollection/" },
				]
			},
		],		
	}

	if(embeddedVersion){
		data.sections = data.sections.filter(s => {
			return !['press','contact'].includes(s.id);
		});
	}

	const hash = window.location.hash.substring(1)
	let activeLanguage = "en";
	let currentMenu = data.sections[0].id;
	let currentMenuLabel = data.sections[0].submenu ? data.sections[0].submenu[activeLanguage] : data.sections[0].menu[activeLanguage];
	let currentSection = data.sections.filter(s => {return s.id === currentMenu})[0];
	var userLang = navigator.language || navigator.userLanguage; 
	if((userLang.match(/^ar-.*$/i)  || userLang === "ar" || hash === "ar") && hash !== "en"){
		activeLanguage = "ar"
	} else {		
		activeLanguage = "en"
	}

	let observerActive = true;
	let submenu;
	let sticky = false;
	let submenuTop;
	let submenuToggled = false;
	let reachedEndOfSubmenuSection = false;

	let y, screenH, skyline, sl_top, sl_height, sl_length;

	$: {
		currentSection = data.sections.filter(s => {return s.id === currentMenu})[0];
		if(y > sl_top - screenH){
			let scrollPercentage = -1.1 * (sl_top - y) / (screenH * 0.7 );
			let drawLength = sl_length * scrollPercentage;
			skyline.style.strokeDashoffset = sl_length - drawLength;			
			// console.log(`skyline - sl_top: ${sl_top} sl_height: ${sl_height} sl_length: ${sl_length} screenH: ${screenH} y: ${y} scrollPercentage: ${scrollPercentage}`)
		}
		// toggle submenu fixed postion
		// console.log(`y: ${y} submenuTop: ${submenuTop}`)
		if (y > submenuTop + 30) {
			sticky = true;
			// console.log("sticky true");
		} else {
			sticky = false;
			// console.log("sticky false");
		}
	}

	onMount( () => {
		// set navigation active based on scroll position
		const scrollSections = document.querySelectorAll('section');

		let observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting && observerActive) {
					currentMenu = entry.target.id;
					currentSection = data.sections.filter(s => {return s.id === currentMenu})[0];
					currentMenuLabel = currentSection.submenu ? currentSection.submenu[activeLanguage] : data.sections[0].menu[activeLanguage];
					reachedEndOfSubmenuSection = false;
					if(["contact-dubai-collection","guide","press","press-coverage","contact"].includes(currentMenu)){
						reachedEndOfSubmenuSection = true;
					}
				} 
			});
		},{threshold: 0.9, rootMargin: "-100px 0px 0px 0px"});
	
		scrollSections.forEach(el => { observer.observe(el); });

		skyline = document.querySelector('#skyline path');
		sl_top = skyline.getBoundingClientRect().top;
		sl_height = skyline.getBoundingClientRect().height;
		sl_length = skyline.getTotalLength();

		submenuTop = submenu.getBoundingClientRect().top;

	});

	const readmore = (id) => {
		// console.log(id);
		document.querySelector('#' + id + ' a').style.display = 'none';
		document.querySelector('#' + id + ' .dots').style.display = 'none';
		document.querySelector('#' + id + ' .more').style.display = 'inline';
	}

	const regexDot = new RegExp(/(.{20,}?\.\s)((?:.|\n|\r)*)/,'gm');


	const scrollToSubmenu = (sectionID) => {
		observerActive = false;
		submenuToggled = false;
		currentMenu = sectionID;
		setTimeout(() => {
			currentMenuLabel = currentSection.submenu ? currentSection.submenu[activeLanguage] : data.sections[0].menu[activeLanguage];
			// console.log("currentMenuLabel",currentMenuLabel);
		}, 200);
		setTimeout(() => {
			observerActive = true;
		}, 2000);
		// window.scrollTo({
		// 	top: document.querySelector('#' + section.id),
		// 	behavior: 'smooth'
		// });
	}

</script>
<svelte:window bind:scrollY={y} bind:innerHeight={screenH} />

<div class="wrapper {activeLanguage}" id="top">
	<header class="{sticky && !reachedEndOfSubmenuSection ? 'sticky-header' : ''}">
		{#if !embeddedVersion}
			<div>
				<h1><a href="#top"><img alt="{data.pageTitle}" id="logo" src="../img/dubai-collection-logo.svg" width="250" height="70" /></a></h1>
				<nav class="languageToggle">
					<ul>
						{#each data.sections as section}
							{#if section.menu}
								<li class:selected="{currentMenu === section.id}" data-id="{section.id}">
									<a on:click="{() => {scrollToSubmenu(section.id)}}" href="#{section.id}">{section.menu[activeLanguage]}</a>				
								</li>
							{/if}
						{/each}
						<li class:selected="{activeLanguage === "en"}">
							<a href="javascript:void(0)"
							on:click="{() => activeLanguage = "en"}">EN</a>				
						</li>
						<li class:selected="{activeLanguage === "ar"}">
							<a href="javascript:void(0)"					
							on:click="{() => activeLanguage = "ar"}">اَلْعَرَبِيَّة</a>				
						</li>
					</ul>
				</nav>
			</div>
		{/if}

		{#if sticky && !reachedEndOfSubmenuSection}
			<div class="toggleBar"  on:click="{() => {submenuToggled = !submenuToggled}}">
				{#if currentMenuLabel && !submenuToggled}
					<p>{currentMenuLabel}</p>
				{/if}
				<div class="toggleIcon {submenuToggled ? 'active' : '' }"></div>
			</div>
			
			<ul class="submenu sticky {submenuToggled ? 'active' : '' }" transition:fly="{{ y: -30, duration: 200 }}">
				{#each data.sections as section}
					{#if section.submenu}
						<li class:selected="{currentMenu === section.id}" data-id="{section.id}">
							<a on:click="{() => {scrollToSubmenu(section.id)}}" href="#{section.id}">{section.submenu[activeLanguage]}</a>				
						</li>
					{/if}
				{/each}
				{#if embeddedVersion}
					<li class:selected="{activeLanguage === "en"}">
						<a href="javascript:void(0)"
						on:click="{() => activeLanguage = "en"}">EN</a>				
					</li>
					<li class:selected="{activeLanguage === "ar"}">
						<a href="javascript:void(0)"					
						on:click="{() => activeLanguage = "ar"}">اَلْعَرَبِيَّة</a>				
					</li>
				{/if}
			</ul>
		{/if}

	</header>
	<main>
		{#each data.sections as section}
			<section id="{section.id}" class:selected="{currentMenu === section.id}" class="{section.layout} {section.type} {section.color && section.color}" 
			style="{section.cover && 'background-image: linear-gradient(0deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.7) 40%, rgba(0,0,0,0) 90%), url(../img/' + section.cover + ');'}">
				<div>
					{#if section.title}
						<h2>{@html section.title[activeLanguage].replace(/(?:\r\n|\r|\n)/g, '<span class="break"></span>')}</h2>
					{/if}
					{#if section.sub_title}
						<p>
							{#if section.author}
								<b>{section.author[activeLanguage]}</b><br/>
							{/if}
							{@html section.sub_title[activeLanguage].replace(/\n———\n/g,'<hr>').replace(/\n\n/g,'<br>')}
						</p>
						{#if section.svg}
							{@html section.svg}
						{/if}
					{/if}

					{#if !sticky && section.placeSubmenu}
						<ul class="submenu" bind:this={submenu} transition:fly="{{ y: -200, duration: 1000 }}">
							{#each data.sections as section}
								{#if section.submenu}
									<li class:selected="{currentMenu === section.id}" data-id="{section.id}">
										<a on:click="{() => {scrollToSubmenu(section.id)}}" href="#{section.id}">{section.submenu[activeLanguage]}</a>				
									</li>
								{/if}
							{/each}
							{#if embeddedVersion}
								<li class:selected="{activeLanguage === "en"}">
									<a href="javascript:void(0)"
									on:click="{() => activeLanguage = "en"}">EN</a>
								</li>
								<li class:selected="{activeLanguage === "ar"}">
									<a href="javascript:void(0)"					
									on:click="{() => activeLanguage = "ar"}">اَلْعَرَبِيَّة</a>
								</li>
							{/if}
						</ul>
					{/if}

					{#if Array.isArray(section.items)}
						{#each section.items as item, i}
							{#if item.lang === activeLanguage || !item.lang}
								<div class="item">
									{#if item.pdfviewer}
										<PdfViewer url='../pdf/{item.pdfviewer}' showBorder="false" scale="2" />
									{/if}
									{#if item.embed}
									   {@html item.embed}
									{/if}
									{#if item.carousel}
										<div class="carousel">
											<Carousel autoplay autoplayDuration={4000} pauseOnFocus>
												{#each item.carousel.images as image}
													<div>
														<img src={'../img/' + image.src} style="width: 100%; height: auto; max-width: 80vw; max-height: 70vh" />
														{#if image.title}
															<p>{image.title}</p>
														{/if}
													</div>
												{/each}}
											</Carousel>					
										</div>			
									{/if}
									{#if item.cover}
										{#if item.link}
											<a href="{item.link}" target="_blank">
												<img src="../img/{item.cover}" width="1000" alt={data.pageTitle} />
											</a>
										{:else}
											<img src="../img/{item.cover}" width="1000" alt={data.pageTitle} />
										{/if}
									{/if}
									{#if item.title}
										<h3>{@html item.title}</h3>
									{/if}
									{#if item.sub_title}
										<p><b>{@html item.sub_title.replace(/\n———\n/g,'<hr>').replace(/\n\n/g,'<br>')}</b></p>
									{/if}
									{#if item.description}
											{#if section.readmore}
												<p id="{item.title.replace(/\s|\./g,'-')}">
													{@html item.description.replace(regexDot,'$1 <span class="dots">...</span><span class="more">$2').replace(/\n/g,'<br><br>') + '</span>'}
													<a on:click="{() => { readmore(item.title.replace(/\s|\./g,'-'))}}">{#if activeLanguage === "en"}Read More{:else if activeLanguage === "ar"}اقرأ أكثر{/if}</a>
												</p>
											{:else}
												{@html '<p>' + item.description.replace(/\n/g,'</p><p>') + '</p>'}
											{/if}
									{/if}
									{#if item.email}
										<a href="mailto:{item.email}">{item.email}</a>
									{/if}
									{#if item.link && !item.hideButton}
										<a href="{item.link}" target="_blank" class="button">
											{#if item.link_label}
												{@html item.link_label.replace(/(?:\r\n|\r|\n)/g, '<span class="break"></span>')}
											{:else if item.link.match(/^.+\.pdf$/i) }												
												{#if activeLanguage === "en"}
													Download PDF
												{:else if activeLanguage === "ar"}
													تحميل PDF
												{/if}
											{:else if item.link.match(/^.+\.docx$/i) }												
												{#if activeLanguage === "en"}
													Download DOCX
												{:else if activeLanguage === "ar"}
													تحميل DOCX
												{/if}
											{:else if item.link.match(/^.*instagram\./i) }
												<img src="../icons/instagram.svg" width="20" height="20" alt="Instagram"/>
											{:else if item.link.match(/^.*facebook\./i) }
												<img src="../icons/facebook.svg" width="20" height="20" alt="Facebook"/>
											{:else if item.link.match(/^.*twitter\./i) }
												<img src="../icons/twitter.svg" width="20" height="20" alt="Twitter"/>
											{:else}
												{item.link}
											{/if}
										</a>
									{/if}
									{#if item.link2 && !item.hideButton}
										<a href="{item.link2}" target="_blank" class="button" style="margin-top: 10px;">
											{#if item.link_label}
												{@html item.link_label.replace(/(?:\r\n|\r|\n)/g, '<span class="break"></span>')}
											{:else if item.link2.match(/^.+\.pdf$/i) }												
												{#if activeLanguage === "en"}
													Download PDF
												{:else if activeLanguage === "ar"}
													تحميل PDF
												{/if}
											{:else if item.link2.match(/^.+\.docx$/i) }												
												{#if activeLanguage === "en"}
													Download DOCX
												{:else if activeLanguage === "ar"}
													تحميل DOCX
												{/if}
											{:else if item.link2.match(/^.*instagram\./i) }
												<img src="../icons/instagram.svg" width="20" height="20" alt="Instagram"/>
											{:else if item.link2.match(/^.*facebook\./i) }
												<img src="../icons/facebook.svg" width="20" height="20" alt="Facebook"/>
											{:else if item.link2.match(/^.*twitter\./i) }
												<img src="../icons/twitter.svg" width="20" height="20" alt="Twitter"/>
											{:else}
												{item.link2}
											{/if}
										</a>
									{/if}
									{#if item.author}
										<p class="secondary">{item.author}</p>
									{/if}
									{#if item.date}
										<p class="secondary">{item.date}</p>
									{/if}
								</div>
							{/if}
						{/each}
					{/if}
				</div>
			</section>
		{/each}
	</main>
</div>

<style type="text/scss">
	* {
		transition: all 100ms ease;
	}
	[id]::before {
		content: '';
		display: block;
		height:      200px;
		margin-top: -200px;
		visibility: hidden;
	}
	.secondary {
		color: var(--grayMedium);
		margin-bottom: var(--gap-xs);
	}
	.secondary + .secondary {
		margin-top: 0;
	}
	img {
		max-width: 100%;
	}
	.wrapper {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		align-content: center;
	}
	.wrapper.en {
		font-family: 'Blinker', sans-serif;
		font-size: 1rem;
		line-height: 1.4;
	}
	.wrapper.ar {
		font-family: 'Almarai', sans-serif;
		font-size: 0.89rem;
		text-align: right;
		direction: rtl;
		line-height: 1.5;
		@media (min-width: 600px) {
			.two-col .item, .contact .item {
				margin-left: var(--gap-m);
				margin-right: 0;
			}
		}
	}
	header {
		transition: all 200ms ease;
		// padding: var(--gap-xs) 0 0 0;
		position: fixed;
		z-index: 10;
    background: #FFF;
		top: 0;
    width: 100%;
		box-shadow: 0 2px 4px rgba(0,0,0,0.05), 0 9px 10px rgba(0,0,0,0.05);
		justify-content: center;
		> div {
			width: 100%;
			justify-content: space-between;
			align-items: center;
			max-width: var(--col-max);
		}		
	}
	header, header > div, nav, nav ul, .submenu {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
	@media (min-width: 700px) {
		.languageToggle {
			order: 2;
		}
	}
	header .submenu {
		display: none;
		&.active {
			display: flex;
		}
		background-color: var(--sand-bright);
		margin: 0;
		width: 100%;
		justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: var(--gap-xs);
		padding-bottom: var(--gap-s);
	}
	@media (min-width: 700px) {
		header .submenu {
			display: flex;
			flex-direction: row;
			gap: 0;
			padding-bottom: 0;
		}
	}
	@media (max-width: 700px) {
		header {
			&.sticky-header {
				font-size: 0.9rem;
				img {
					height: 50px;
					width: 170px;
				}
			}
			div {
				justify-content: center;
			}
		}	
	}
	nav ul, .submenu {
		list-style: none;
		align-items: flex-end;
		margin: 0 var(--gap-s);
		padding: 0;
		li {
			padding: var(--gap-xs) 0;
			margin-right: var(--gap-s);
			border-bottom: 4px solid transparent;
			&.selected {
				font-weight: 600;
				border-bottom-color: var(--sand);
			}
			a {
				color: var(--text);
				text-decoration: none;
			}
		}
	}
	section .submenu {
		justify-content: center;
	}
	.submenu li {
		margin-right: calc(5px + 2vw);
	}
	.toggleBar {
		width: 100%;
		height: 40px;
		position: relative;
		background: var(--sand-bright);
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-content: center;
		p {
			margin: 0;
			font-weight: bold;
		}
	}
	.toggleIcon {
		cursor: pointer;
		&:before, &:after {
			left: 15px;
			top: 0;
			content: "";
			position: absolute;
			transform: translate(0, 14px);
			background: var(--text);
			height: 2px;
			width: 20px;
			transition: all 200ms ease;
		}
		&:after {
			transform: translate(0, 22px);
		}
		&.active {
			&:before{
				transform: translate(0, 20px) rotate(-45deg);
			}
			&:after {
				transform: translate(0, 20px) rotate(45deg);
			}
		}
	}
	@media (min-width: 700px) {
		.toggleBar {
			display: none;
		}
	}
	main {
		width: 100%;
		// margin-top: 90px;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		align-items: center;
		/* scroll-snap-type: y proximity; */
	}
	h1, h1 img {
		padding: 0;
		margin: 0;
	}
	h1, h2 {
		max-width: 75ex;
	}
	h2 {
		padding-top: 50px;
		font-size: 1.2rem;
	}
	:global(h2 em) {
		font-weight: 200;
		font-style: normal;
		color: var(--bg);
		font-size: calc(2rem + 0.5vw + 0.5vh);
	}
	@media (min-width: 700px) {
		h2 {
			font-size: 1.4rem;
		}
	}
	@media (min-width: 1000px) {
		h2 {
			font-size: 1.6rem;
		}
	}
	p {
		max-width: 70ex;
	}
	:global(p hr) {
		max-width: 10ex;
		margin: var(--gap-s) 0;
		border-top: 1px solid var(--text);
		border-bottom: none;
	}
	a:hover {
		opacity: 0.85;
	}
	:global(.break) {
		display: block;
		margin-bottom: var(--gap-s);
	}
	:global(.button .break, h2 .break) {
		display: block;
		margin-bottom: 0;
	}
	.two-col-feature h2 {
		transform: scale(0.99) translateY(+10px);
	}
	.two-col-feature.selected h2{
		transform: scale(1.02) translateY(-10px);
		transition: all 500ms ease 200ms;
	}
	@media (max-width: 700px) {
		section:first-of-type {
			margin-top: 40px;
		}
		[data-id="dubai-collection-guide"]{
			// display: none;
		}
	}
	section {
		scroll-snap-align: start;
		min-height: 25vh;
		display: flex;
		flex-direction: column;
		opacity: 0;
		animation: slideUp 300ms cubic-bezier(0.375, 0.285, 0.32, 1.175) forwards;
		&:not(:last-of-type){
			margin-bottom: 5vh;
		}
		&:nth-of-type(2n){
			animation-delay: 150ms;
		}
		&:nth-of-type(3n){
			animation-delay: 300ms;
		}
		&:nth-of-type(4n){
			animation-delay: 400ms;
		}
		&:last-of-type {
			animation: none;
			opacity: 1;
		}
		&.full {
			width: 100%;
		}
		&.bigtitle {
			margin-bottom: var(--gap-s);
			min-height: 0;
			div {
				justify-content: center;
			}
			p, h2 {
				text-align: center;
			}
			p {
				margin: 0 auto;
				font-weight: 400; 
				font-size: 1.5rem;
				&:after {
					content: "↓";
					font-weight: 200;
					font-size: var(--font-l);
					display: block;
					color: var(--sand);
				}
			}
			h2 {
				margin: var(--gap-m) auto var(--gap-xs);
				font-size: var(--font-l);
				text-transform: uppercase;
				color: var(--sand);
			}
		}
		&.embed .item{
			background-color: var(--sand-bright);
		}
		&.quote {
			div {
				// display: flex;
				// flex-direction: row;
				// gap: 0;
				grid-template-columns: 66% 34%;
				:global(h2) {
					// width: 66% !important;
					font-weight: 300;
					&:before {
						content: "“";
						font-weight: bold;
						font-size: 13rem;
						color: var(--sand);
						display: inline-block;
						line-height: 0;
						vertical-align: bottom;
						margin-right: 10px;
					}
					&:after {
						display: none;
					}
				}
				:global(svg) {
					width: 100%;
					position: absolute;
					z-index: -1;
					left: 0;
					bottom: var(--gap-m);
				}
				:global(svg path) {
					stroke-dasharray: 7922;
					stroke-dashoffset: 7922;
					// animation: dash 5s linear forwards;
				}
				// :global(p) {
				// 	width: 100%;
				// 	order: 3;
				// }
			}
		}
		&.portrait {
			> div {
				justify-content: center;
			}
			h2, h3 {
				text-align: center;
				margin: var(--gap-s) auto;
				width: 100%;
			}
			h3 {
				margin-bottom: 0;
			}
			.item {
				flex-direction: row;
				justify-content: center;
				gap: var(--gap-s);
				:global(p) {
					max-width: 66ex;
					margin: 0;
					color: var(--grayMedium);
				}
			}
			img {
				max-height: 200px;
				max-width: 200px;
				object-fit: cover;
				object-position: center;
				box-shadow: 0 2px 4px rgba(0,0,0,0.05), 0 9px 10px rgba(0,0,0,0.05);
				border-radius: 100%;
			}
		}
		:global(&.portrait + .portrait, .download + .download) {
			border-top: 1px solid var(--grayLight);
		}
		:global(&.portrait + .embed) {
			border-top: 1px solid var(--grayLight);
			padding-top: var(--gap-m);
		}
		.button{
			color: var(--bg);
			text-decoration: none;
			background-color: var(--gray);
			padding: var(--gap-xs) var(--gap-s) ;
			text-transform: uppercase;
			border-radius: 2px;
		}
		img {
			border-radius: 2px;
		}
		&.contact {
			background-color: var(--text);
			* {
				color: var(--bg);
			}
			.button {
				background-color: transparent;
				padding: var(--gap-s);
			}
			> div {
				flex-direction: row;
				h2 {
					width: 100%;
					max-width: none;
				}
				.item {
					margin-right: var(--gap-s);
					a {
						padding: var(--gap-xs) var(--gap-xs) var(--gap-xs) 0;
						text-decoration: none;
					}
				}
			}
		}
		&.cover {
			background-size: cover;
			background-position: center;
			color: var(--bg);
			justify-content: flex-end;
			min-height: 70vh;
			animation: slideUp 450ms cubic-bezier(0.375, 0.285, 0.32, 1.175) forwards;
			h2, p {
				/* align-self: center; */
			}
		}
		&.cover:not(.two-col-feature){
			h2 {
				font-weight: 300;
				margin-top: 40vh;
				text-shadow: 0 0 20px rgba(0,0,0,3);
				// backdrop-filter: blur(20px);
				position: relative;
				&:before {
					content: "";
					display: block;
					height: var(--gap-xs);
					width: 80px;
					background-color: var(--sand);
					margin-top: calc(-1 * var(--gap-s));
					position: absolute;
				}
			}
			p {
				color: var(--sand);
				font-style: italic;
			}
		}
	}
	.one-col, .two-col, .full, .center-one-col, .two-col-feature {
		width: 100%;
		align-items: center;
		.item {
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			align-content: flex-start;
			margin-bottom: var(--gap-m);
			a {
				width: fit-content;
			}
		}
		> div {
			width: 100%;
			padding: var(--gap-s);
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
		}
	}
	.one-col, .two-col, .full > div {
		max-width: var(--col-max)
	}
	.center-one-col {
		justify-self: center;
		text-align: center;
		 > div {
			max-width: calc( var(--col-max) / 2);
			h2, p {
				max-width: none;
			}
			h2 {
				margin-bottom: var(--gap-xs);
			}
			h2 + p {
				margin-top: 0;
			}
		}
	}
	.two-col, .two-col-feature {
		> div {
			flex-direction: row;
			> h2 {
				width: 100%;
			}
			@media (min-width: 600px) {
				.item {
					margin-right: var(--gap-m);
					width: calc(50% - var(--gap-m));
				}
			}
		}
	}
	.two-col-feature {
		@media (min-width: 600px) {
			&:nth-child(odd) {
				div h2 {
					grid-column: 2;
				}
			}
		}
		margin-bottom: 0 !important;
		background-size: cover;
		background-position: center;
		@media (min-width: 600px) {
			min-height: clamp(40vh,370px,370px);
			justify-content: center;
			div {
				display: grid;
				grid-auto-flow: column;
				grid-template-columns: 50%;
				row-gap: var(--gap-m);
				column-gap: var(--gap-s);
				max-width: var(--col-max);
				padding: var(--gap-m);
				box-sizing: border-box;
				h2, p {
					// width: 100%;
					margin-top: var(--gap-xs);
					box-sizing: border-box;
					padding: var(--gap-m);
				}
			}
		}
		h2 {
			font-size: var(--font-l);
			&:after {
				content: "";
				display: block;
				height: var(--gap-xs);
				width: 80px;
				background-color: var(--sand);
				margin-top: var(--gap-s);
				position: absolute;
			}
		}
		:global(p hr) {
			border-top: 1px solid var(--bg);
		}
		&.blue {
			> div:first-child {
				h2 {
					color: var(--blue);
				}
			}
		}
		&.green {
			> div:first-child {
				h2 {
					color: var(--green);
				}
			}
		}
		&.sand {
			> div:first-child {
				h2 {
					color: var(--sand);
				}
			}
		}
		// &.blue:not(.cover), &.green:not(.cover), &.sand:not(.cover) {
		// 	@media (max-width: 599px) {
		// 		h2 {
		// 			padding: var(--gap-m);
		// 		}	
		// 	}
		// }
		&.cover {
			background-attachment: fixed;
			&.blue, &.green, &.sand {
				h2 {
					background-color: transparent !important;
				}
			}
			&.blue h2 {
				color: var(--blue);
			}
			&.green h2 {
				color: var(--green);
			}
			&.sand h2 {
				color: var(--sand);
			}			
			div {
				min-height: 0;
				h2 {
					margin-top: var(--gap-xs);
					height: min-content;
					grid-column: 1;
					padding-bottom: var(--gap-l);
					place-self: flex-start;
				}
				h2, p{
					text-shadow: 0 0 3px rgba(0,0,0,0.3), 0 0 20px rgba(0,0,0,0.5);
				}
				@media (min-width: 600px) {
					p {
						backdrop-filter: blur(20px);
						transition: all 350ms ease;
						&:hover {
							background-color: rgba(0,0,0,0.2);
							// backdrop-filter: blur(30px);
						}
					}
				}
			}
		}
		@media (max-width: 600px) {
			&.cover {
				background-attachment: scroll;
				&.sand h2 {
					color: var(--bg) !important;
				}
			}	
		}
		&.cover + .cover {
			div h2 {
				grid-column: 2;
			}
		}
		&.cover + .cover + .cover {
			div h2 {
				grid-column: 1;
			}
		}
	}

	
	:global(#pdf-wrapper, #pdf-wrapper *) {
		direction: ltr;
	}
	:global(#pdf-wrapper canvas) {
		max-height: calc(90vh - 140px);
		max-width: 100%
	}
	iframe {
		min-height: 70vh;
	}
	#dubai-collection-guide {
		background-attachment: initial;
	}

	:global(.dots) {
		white-space: nowrap;
		display: inline-block;
		margin-left: 5px;
		letter-spacing: 3px;
	}
	:global(.more) {
		display: none;
		& + a {
			color: var(--sand);
			cursor: pointer;
		}
	}
	:global(b a) {
		color: var(--blue);
		text-decoration: none;
	}

	#carousel{
		margin: 0 auto !important;
	}
	:global(#carousel .item){
		margin-bottom: var(--gap-s);
		place-items: center;
		place-content: center;
	}
	:global(#carousel .item p){
		margin: 0 auto;
		max-width: 90ex;
	}
	:global(#carousel .item h3){
		font-weight: 400;
		font-size: var(--font-m);
		max-width: 70ex;
	}
	#carousel + #dubai-collection-guide h2 {
		padding-top: 0;
	}
	.carousel {
		direction: ltr;
		width: 100%;
		display: flex;
		place-content: center;
		max-width: calc(var(--col-max) - 2* var(--gap-s));
		margin: 0 auto !important;
	}
	:global(.sc-carousel__pages-container){
		max-height: 50vh;
	}
	:global(.sc-carousel__pages-container div){
		display: flex;
		max-height: 50vh;
		place-items: center;
		place-content: center;
		flex-direction: column;
		gap: var(--gap-xs);
		text-align: center;
		direction: inherit;
	}
	:global(.carousel p) {
		margin-top: 0;
		margin-bottom: var(--gap-s)
	}
	:global(.carousel img) {
		pointer-events: none;
		max-height: calc(50vh - 50px) !important;
		object-fit: contain;
	}
	:global(.sc-carousel-arrow__arrow) {
		border-color: #FFF !important;
	}
	:global(.sc-carousel-arrow__circle) {
		width: 45px !important;
		height: 45px !important;
		background-color: var(--grayMedium) !important;
	}

</style>
